import type React from 'react';

function RoyalMailIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 338.32 338.32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Royal Mail Icon</title>

      <g id="svg1898">
        <g>
          <path
            d="M28.41,136.42c2.88-21.33,16.89-36.85,37.21-40.84,8.04-1.58,15.98-.45,23.76,2.03,8.33,2.65,16.02,6.77,24.05,10.11,11.59,4.82,23.52,8.64,35.72,12.32,.94-2.54-.14-4.79-.27-7.02-.15-2.45,.35-3.81,3.05-4.04,1.64-.14,3.21-.95,4.93-.7,.62,3.38,1.96,6.62,1.87,10.13-1.27,1.02-.64,2.54-.98,3.81-.49,0-.99-.02-1.48,.02-4.85,.34-5.36,.86-5.41,5.53-.02,1.48,.02,2.95,.03,4.43-15.47-2.83-30.71-6.53-45.66-11.45-7.3-2.4-14.57-4.99-22.2-6.15-18.42-2.79-31.7,6.5-36.13,22.65-.57,2.08-.35,4.36-1.6,6.26-.26-.39-.93-1.49-.94-.74-.17,7.67-.65,15.37,.15,23.01,.62,5.92,1.78,11.78,2.64,17.68,.22,1.53,.12,3.16-1.55,3.87-1.77,.75-2.6-.55-3.58-1.83-2.78-3.62-4.35-7.86-6.21-11.92-4.09-8.95-7.82-18.02-6.85-28.29,.27-2.9,.78-5.99-.54-8.87Zm28.65-32.48c-.61,.41-1.04,.95-1.2,1.68-1.13,.33-2.27,.66-3.4,.99-2.18-.69-2.32,.82-2.48,2.3-2.42,.61-4.82,1.26-5.31,4.28-1.35,1.16-3.15,1.9-3.6,3.89-1.37,.14-1.98,1.15-2.45,2.24-2.87,6.6-5.02,13.41-5.49,20.63-.52,8.05,.28,15.96,2.99,23.63,.54,1.54,.6,3.9,2.66,3.58,2.24-.35,1.35-2.76,1.28-4.25-.25-5.45-.28-10.87-.06-16.32,.14-3.51,1.72-6.84,1.04-10.39,.09-.56,.17-1.11,.26-1.67,1.25-.32,1.94-1.03,1.63-2.41,.1-1.25,.2-2.49,.3-3.74,1.46-2.31,3.16-4.48,4.03-7.12,2.79-1.92,5.22-4.19,6.96-7.14,.52-.11,1.03-.22,1.56-.32,.32,.07,.69,.27,.96,.18,4.36-1.48,8.45-3.76,13.09-4.45,.28-.04,.44-.83,.66-1.28l1.78-.06c2.4,1.5,4.79,1.49,7.19,0,1.26,.04,2.52,.07,3.78,.11,.25,.83,.65,1.55,1.6,1.72,13.31,2.47,25.89,7.59,39.01,10.71,3.05,.73,6.05,2.06,9.33,1.88-.02-1.25-.73-1.49-1.31-1.72-12.08-4.83-24.03-9.98-35.89-15.34-4.04-1.82-8.14-3.88-12.75-4.18-.98,0-2.04,.23-2.93-.05-5.26-1.69-10.38-.8-15.53,.48-1.11,.27-2.29,.21-3.44,.3-1.65,.07-3.6-.53-4.27,1.83Z"
            fill="#ebb740"
          />
          <path
            d="M298.95,196.23c.63,1.83-.56,3.21-1.22,4.69-2.67,5.94-5.38,11.86-8.08,17.79-4.61-.22-5.72,.43-6.9,4.05-2.91,4.77-2.91,8.46-.02,12.12-2.16,5.39-3.77,10.96-4.91,16.64-.41,2.02-.98,3.96,1.5,5.66,2.38,1.63,2.17,5.24-.4,6.05-3.58,1.14-3.02,3.79-3.6,6.17-2.84-.55-5.65-.06-8.51,.22,3.72,1.23,6.96,3.75,11.06,3.57,1.29,.68,2.19,1.7,2.76,3.04-4.91,.31-9.43-1.18-13.85-3.08-1.68-.72-3.33-1.48-5.23-.98,0,0,.05,.05,.05,.05,.38-1.31-.58-2.1-1.17-3.04,.24-.22,.46-.47,.73-.65,.87-.58,2.51-.47,2.2-2.14-.25-1.34-1.52-1.65-2.61-1.95-.77-.22-1.63-.23-2.44-.23-3.95,0-7.91,.02-11.86,.03-12.34-.52-24.69,.08-37.06-.85-11.31-.85-22.74-.15-34.11-.13-4.52,.02-9.04,.03-13.56,.05-1.84-.05-3.68-.06-5.52-.14-14.89-.61-29.73,1.11-44.6,.98-10.14,.02-20.27,.04-30.41,.06-1.67,0-3.36-.12-4.61,1.32-.87,.99-1.47,1.91,.31,2.62,.59,.24,1.1,.68,1.65,1.03-.05,.35-.1,.7-.15,1.06l.04-.07c-1.04,.33-1.28,1.09-1.07,2.07l.05-.05c-2.11-.57-3.85,.54-5.72,1.18-3.72,1.27-7.27,3.42-11.48,2.46,.02-.56,.04-1.11,.05-1.67,0,0-.05,.07-.05,.07,.36-.37,.72-.73,1.07-1.1,0,0-.1,.06-.1,.06,4.11,.23,7.27-2.47,11.01-3.53-2.93-.29-5.78-.79-8.65-.24-.38-2.53-.12-5.08-3.62-6.21-2.17-.7-2.48-4.7-.53-5.87,2.83-1.71,2.09-3.91,1.64-6.1-1.14-5.57-2.73-11.01-4.84-16.3,3.55-4.04,2.44-8.09,0-12.13-1.23-3.18-3.27-4.98-6.91-4.06-3.23-7.01-6.45-14.02-9.68-21.02,.46-.7,.92-1.39,1.38-2.09,0,0,.07-.07,.07-.07,5.6,.63,10.35-2.94,15.76-3.51,.34,1.9-.62,3.19-.9,4.62-.73,3.74-2.79,7.16-2.72,11.1-.03,.35-.06,.71-.1,1.06-1.55,2.13-1.12,3.8,1.19,5.02v-.04c.38,.58,.9,.9,1.61,1,4.41,.64,5.6,1.69,6.34,5.92,.23,1.31,.35,2.58,.9,3.83,2.05,4.66,2.01,4.68,1.16,8.44-.37,.35-.75,.69-1.12,1.04-1.1,1.52-.82,3.13-.37,4.78,1.75,6.44,6.14,9.61,12.6,10.28,0,3.01,.05,6.02-.02,9.02-.05,2.13,.89,3.02,3,2.99,2.5-.04,5.07-.28,7.5,.17,8.3,1.52,16.63,.72,24.95,.57,18.05-.2,36.1,.9,54.14-.58,5.14-.42,10.34,.49,15.48,.58,17.9,.31,35.81,.04,53.71,0,9.83,1.09,19.58-.46,29.37-.79,.8-.03,1.62-.35,2.37-.68,1.5-.64,2.1-1.83,1.03-3.16-1.42-1.78-1.49-3.5-.81-5.59,.44-1.35-.92-1.47-1.89-1.64,.92-1.22,3.25-.7,3.45-2.8,4.82-.49,6.53-3.78,7.19-8,.63-.28,.85-.79,.82-1.44,.02-.25,0-.51-.02-.76,1.38-.97,1.06-1.96,.03-2.96-2.02-3.24-1.42-6.47-.01-9.72,.66-1.52,1.61-3.01,1.84-4.6,.55-3.9,2.78-5.3,6.45-5.05,.25-.28,.5-.56,.74-.84,2.97-1.64,2.12-4.27,1.48-6.62-1.1-4.02-2.49-7.96-3.76-11.93-.34-1.07-1.15-2.13,.13-3.36,1.8,.57,3.69,1.2,5.59,1.77,3.18,.95,6.25,2.44,9.72,1.93,0,0,.06,.07,.06,.07,.12,.57,.45,.76,1,.58Z"
            fill="#c68f43"
          />
          <path
            d="M189.22,119.96c11.97-3.06,23.6-7.14,35-11.87,7.55-3.13,14.97-6.61,22.6-9.52,10.05-3.83,20.43-5.15,30.95-1.95,13.99,4.26,23.84,13.29,29.28,26.81,5.83,14.5,5.76,29.27,.99,44.08-1.11,.53-1.1,1.55-1.08,2.56,0,0,.07,.31,.07,.31-2.87,2.93-4.67,6.54-5.96,10.32-.91,2.65-2.53,4.66-4.18,6.75-1.21,1.52-2.7,2.71-4.71,1.74-2.07-1-2.75-2.93-2.26-5.09,1.94-8.59,3.45-17.26,4.51-26,.47-3.91,1.26-7.9-.53-11.73-1.03-4.02-1.62-8.11-2.99-12.09-3.9-11.38-14.23-19.83-27.55-20.11-6.11-.13-11.97,1.05-17.7,2.92-18.89,6.17-37.99,11.52-57.51,15.34-.52-2.39,.97-4.56,.78-6.91,.11-1.85,.21-3.7,.32-5.54Zm105.48-7.67c-1.57-1.97-2.81-4.43-5.99-4l-.07-.07c.21-1.91-1.24-2.48-2.54-3.24-2.91-1.72-6.22-2.22-9.37-3.2-2.38-2.57-3.44-2.84-6.19-1.56-3.44-.1-6.87-.15-10.11,1.28-.31-.08-.58-.22-.82-.42-.15-.72-.16-1.68-1.23-1.53-.66,.09-.77,.84-.88,1.44-.63,.08-1.26,.15-1.89,.23-.71-1.14-1.61-.78-2.61-.41-4.84,1.8-9.87,3.22-14.53,5.4-12.4,5.79-24.89,11.36-37.65,16.32-.85,.33-2,.52-2.09,1.84,.59,1.25,1.68,.92,2.59,.69,6.13-1.55,12.23-3.18,18.35-4.76,12.07-3.12,23.84-7.38,36.13-9.66,6.87-1.27,13.81-.79,20.15,1.96,7.47,3.25,13.56,8.45,17.06,16.15,.54,1.19,1.05,2.54,2.72,2.62,1.37,.97,1.04,2.48,1.21,3.84-.52,.43-1.16,.93-.96,1.62,1.4,4.8,2.14,9.68,1.91,14.69-.06,1.19,.75,1.76,1.84,1.97,0,1.66,0,3.32,0,4.98-.45,.2-1.21,.31-1.3,.61-1.14,4.05-.64,8.18-.33,12.27,.08,1.04,1.39,1.07,1.88,.29,2.32-3.69,4.55-7.46,3.96-12.13,.02-.67,.04-1.34,.06-2,1.12-.17,1.62-.82,1.91-1.94,1.66-6.56,1.27-13.19,.53-19.77-.25-2.23-.44-4.61-1.46-6.77-.48-1.03-1.03-1.64-2.11-1.79-.73-1.94-1.46-3.88-2.19-5.82-.04-2.01-.51-3.74-2.77-4.31-.04-.26-.09-.52-.15-.77,.03-2.14-1.28-3.26-3.06-4.03Z"
            fill="#ebb740"
          />
          <path
            d="M273.82,289.28c.95,.27,1.89,.6,2.85,.81,6.99,1.47,11.43,7,10.78,13.44-.74,7.36-5.94,12.05-13.54,12.05-17.94,.02-35.88-.04-53.82-.03-51.48,0-102.95,.03-154.43,.04-7.9,0-12.49-3.63-13.9-10.94-1.15-5.94,2.54-12.4,8.31-14.38,1.56-.54,3.25-.74,4.51-1.95,1.41,1.41,3.31,.95,4.99,1.34,3.88,1.34,7.89,.25,11.82,.63,1.74,.17,3.71-.66,5.11,1.1-1.99,0-3.98,0-5.97,0-1.34-.03-2.68-.11-4.02-.1-5.59,.07-9.74,3.98-10.16,9.51-.4,5.29,3.89,11.35,9.05,11.43,5.54,.09,10.96,1.2,16.48,1.2,47.81-.03,95.61-.02,143.42-.01,9.2,0,18.39,.11,27.55-.97,4.99-.59,9.75-5.4,9.83-10.36,.1-5.9-4.69-10.76-10.67-10.8-1.51,0-3.02,.06-4.53,.09-1.32,0-2.65,.01-3.97,.02,1.4-1.77,3.37-.96,5.11-1.1,4.27-.34,8.6,.63,12.83-.63,.79-.13,1.59-.26,2.38-.4Z"
            fill="#889fa8"
          />
          <path
            d="M180.06,66.57c6.75,2.08,9.72,7.53,11.83,13.58,.75,2.14,1.24,4.47,.89,6.84-1.12,.86-2.39,1.06-3.78,1.05-14.24-.07-28.48-.11-42.73-.16-.48-2.35-.22-4.62,.69-6.83,1.78-.18,3.46,.1,5.02,1.01,4.52,1.72,9.19,.75,13.8,.8,2.44,.02,4.88,.04,7.32,.06,3.35,.01,6.7,.04,10.04,.04,.74,0,1.32-.22,.75-1.14,.56-3.67-.11-7.07-2.03-10.28-.9-1.51-1.94-3.05-1.81-4.96Z"
            fill="#f7c942"
          />
          <path
            d="M28.41,136.42c1.32,2.88,.81,5.97,.54,8.87-.97,10.27,2.75,19.34,6.85,28.29,1.86,4.06,3.43,8.3,6.21,11.92,.98,1.28,1.81,2.58,3.58,1.83,1.67-.71,1.78-2.34,1.55-3.87-.86-5.9-2.02-11.76-2.64-17.68-.8-7.64-.32-15.34-.15-23.01,.02-.75,.68,.35,.94,.74-.04,2.49-.18,4.98-.09,7.46,.4,10.67,2.45,20.97,6.95,30.72,.24,3.22,1.46,6.1,3.11,8.83-4.74,1.41-9.14,3.93-14.18,4.35-5.15-10.02-8.94-20.56-11.6-31.47-1.1-4.5-1.98-9.17-1.49-13.91,0-2.07,0-4.14,0-6.22-.21-2.31-.11-4.59,.42-6.85Z"
            fill="#c68f43"
          />
          <path
            d="M155.83,105.1c-5.47-3.56-8.43-8.64-9.19-15.07,2.9-.44,4.78,.76,6.83,2.94,7.63,8.09,16.88,7.56,24.8-1.56,2.28-.11,4.56-.23,6.83-.34,1.03,.05,2.06,.11,3.09,.16-3.34,9.05-15.52,16.59-28.39,14.07-1.29-.25-2.65-.14-3.98-.2Z"
            fill="#ebb740"
          />
          <path
            d="M199.04,94.09c5.74-3.36,11.47-2.08,14.57,3.26,2.89,4.97,1.14,11.48-3.87,14.33-5.26,3-11.85,1.2-14.57-4.23-1.93-3.86-1.58-7.73,1.01-11.29,1.59,1.28,.49,3.14,1,4.65,.7,2.07,2.05,3.28,4.33,3.44,2.73,.19,5.53-1.35,6.41-3.7,.74-1.98-.15-3.42-1.47-4.88-2.15-2.4-4.85-1.58-7.43-1.57Z"
            fill="#9eafb3"
          />
          <path
            d="M11.93,156.46c5.33-3.17,10.47-2.06,13.72,2.97,2.99,4.63,1.78,11.2-2.63,14.27-4.75,3.31-11.38,2.2-14.66-2.48-2.67-3.82-2.79-7.71-.26-11.65,.27-.02,.55-.05,.82-.1-.14,2.05,.15,3.99,1.39,5.72,1.61,2.23,3.82,2.97,6.12,2.02,2.4-1,3.95-3.77,3.64-6.52-.29-2.64-1.75-4.06-4.59-4.31-1.16-.1-2.34,.01-3.51,.03l-.05,.05Z"
            fill="#9eafb3"
          />
          <path
            d="M165.79,82.86c-4.61-.05-9.29,.91-13.8-.8,1.44-.06,2.9,.11,4.28-.44,2.19,0,4.39,0,6.58,0,.57,.22,.96,.08,1.07-.57,.51-3.37,.16-6.73-.07-10.09,.02-1.02,.04-2.05,.05-3.07,0-1.33,0-2.66,0-3.99,.55-1.62,.74-2.99-1.66-3.09-1.47-.06-2.98,.3-4.51-.36-.03-1.71,1.12-2.65,2.28-3.59,6.3,2.06,12.6,2.07,18.9,.02,1.01,.83,1.93,1.72,2.1,3.47-1.58,.84-3.39,.32-5.07,.47-2.07,.19-1.7,1.5-1.39,2.81-.28,1.84-.43,3.68-.07,5.52-.14,3.1-.18,6.22-.46,9.31-.28,3.08,1.39,3.63,3.88,3.38,.39-.03,.79-.05,1.18-.08,1.6,.01,3.2,.03,4.81,.04,.57,.92-.01,1.14-.75,1.14-3.35,0-6.7-.02-10.04-.03-.06-2.5-.15-5.01-.16-7.51-.01-2.46-1.7-2.49-3.45-2.48-1.72,.01-3.47-.05-3.51,2.42-.04,2.5-.13,5.01-.2,7.51Z"
            fill="#c68f43"
          />
          <path
            d="M175.02,31.69q.14,3.85,4.11,4.16c.95,3.91,1.03,7.82,.03,11.73q-3.97,.36-4.07,4.21c-3.75,1.3-7.5,.36-11.25-.03q-.18-3.7-4.05-4.22c-1-3.89-.91-7.78,.03-11.67q3.84-.45,4.09-4.17c3.7,0,7.41-.01,11.11-.02Zm-5.18,4.99c-2.07,.14-4.18,.2-4.89,2.75-1.48,4.19-.52,6.59,3.11,7.78,2.52,.83,5.92-1.02,6.74-3.65,1.01-3.23-.97-5.98-4.96-6.88Z"
            fill="#fddf79"
          />
          <path
            d="M275.82,73.02c1.34,.05,2.72-.09,4.01,.18,6.18,1.27,9.56,7.19,7.81,13.53-1.41,5.14-7.65,8.44-12.83,6.78-6.21-1.99-9.21-8.06-6.86-13.93,.76-1.91,1.89-3.54,3.7-4.63,.98,1.29-.48,1.65-.93,2.37-1.74,2.81-1.46,5.13,.89,7.02,2.87,2.31,5.16,2.15,7.86-.54,2.65-2.65,2.92-4.94,1.11-7.45-1.23-1.71-3.28-2.08-4.77-3.34Z"
            fill="#9eafb3"
          />
          <path
            d="M155.83,105.1c1.33,.06,2.69-.05,3.98,.2,12.87,2.51,25.04-5.03,28.38-14.08,.63-.06,1.26-.11,1.89-.17,.66,0,1.32-.02,1.97-.03-.68,5.83-3.77,10.22-8.12,13.94-1.04,.89-3.01,1.11-2.72,3.17-.32,1.35,.39,2.89-1.06,4.6-.16-2.55-1.73-2.53-3.31-2.53-4.52,.01-9.04,.08-13.56,0-2.32-.04-3.36,.83-3.31,3.22,.07,3.68-.02,7.37-.05,11.05-1.69-1.76-.62-4.07-1.2-6.05,.1-3.51-1.25-6.75-1.87-10.13,2.23-1.89-.86-2.06-1.03-3.18Z"
            fill="#c68f43"
          />
          <path
            d="M59.4,73.02c1,0,2.02-.09,3,.04,6.22,.81,10.16,6.01,9.13,12-1.03,5.98-6.84,10.05-12.41,8.71-6.22-1.5-9.57-7.21-7.83-13.42,.22-.8,.63-1.54,.95-2.31,1.45,.88,.73,2.41,1.09,3.62,.71,2.38,3.02,4.2,5.47,4.34,2.59,.15,5.05-1.27,6.09-3.49,.99-2.13,.24-4.93-1.38-6.89-1.14-1.38-3.1-1.19-4.1-2.6Z"
            fill="#9eafb3"
          />
          <path
            d="M190.08,91.05c-.63,.06-1.26,.11-1.89,.17-1.03-.05-2.06-.1-3.09-.16-.69-.89-1.68-.99-2.69-.99-8.82,0-17.63,0-26.9,0,2.12,1.85,4.23,1.95,6.37,1.96,5.47,.03,10.95,.17,16.39-.63-7.92,9.12-17.18,9.65-24.8,1.56-2.05-2.18-3.93-3.38-6.83-2.94-.73-.62-.73-1.35-.36-2.15,14.24,.05,28.48,.09,42.73,.16,1.39,0,2.66-.19,3.78-1.05,.4,1.12,.35,2.17-.54,3.06-.87,0-1.7,.11-2.15,1Z"
            fill="#fddf79"
          />
          <path
            d="M109.76,82.18c3.2-.49,5.94,.4,8.32,2.6,3.97,3.67,4.8,8.9,2.03,13.19-2.91,4.51-8.33,6.2-13.2,4.1-4.9-2.11-7.15-7.03-5.67-12.42,.13-.48,.3-.96,.45-1.44,.99,.67,.63,1.83,.98,2.72,1.32,3.39,5.03,5.76,7.76,5.04,3.1-.82,5.78-5.04,5.19-8.22-.61-3.25-3.37-4.28-5.86-5.57Z"
            fill="#9eafb3"
          />
          <path
            d="M293.86,146.36c1.79,3.84,1,7.83,.53,11.73-1.06,8.74-2.57,17.4-4.51,26-.49,2.16,.19,4.09,2.26,5.09,2.02,.97,3.51-.22,4.71-1.74,1.65-2.08,3.27-4.09,4.18-6.75,1.29-3.77,3.1-7.39,5.96-10.32-1.61,8.68-5.39,16.56-9.14,24.44-4.97-.61-9.47-2.78-14.17-4.3,1.58-2.72,2.87-5.54,3.06-8.74,.88-.66,.97-1.71,1.3-2.64,3.75-10.6,5.88-21.5,5.81-32.78Z"
            fill="#c68f43"
          />
          <path
            d="M254.58,73.87c5.02,1.08,7.34,4.67,7.74,9.31,.38,4.36-1.89,7.76-5.76,9.82-3.97,2.12-7.83,1.36-11.35-1.16-3.78-2.7-4.2-6.6-3.56-10.81,.27-.36,.53-.72,.8-1.08,0,0,0-.02,0-.02,.52,.44,.86,.96,.95,1.66,.37,2.98,2.12,4.76,4.97,5.38,3.47,.76,5.76-1.33,7.37-3.88,1.5-2.36,1.47-5.01-.73-7.23-.56-.56-1.3-1.14-.42-2.02Z"
            fill="#9eafb3"
          />
          <path
            d="M280.75,276.97c-1.08,3.5-4.27,5.38-6.28,8.16-5.31,.07-10.63,.14-15.94,.2-1.01-.88-.75-2.08-.82-3.21-.24-4.12,.56-8.17,.9-12.25,.99,.78,1.98,1.57,2.98,2.35,0,0-.05-.05-.05-.05,2.47,4.11,6.06,5.64,10.82,5.03,2.76-.35,5.59-.17,8.39-.23Z"
            fill="#d12438"
          />
          <path
            d="M64.45,285.15c-2-2.78-5.21-4.63-6.23-8.16,2.8,.05,5.63-.16,8.38,.22,4.8,.66,8.29-1.05,10.82-5.04,0,0-.05,.05-.05,.05,.71-.51,1.42-1.01,1.07-2.07,0,0-.04,.07-.04,.07,.73,.3,1.31-.16,1.93-.4,0,5.17,.86,10.34,.1,15.52-5.32-.06-10.64-.13-15.96-.19Z"
            fill="#d12438"
          />
          <path
            d="M159.92,124.46c.03-3.68,.12-7.37,.05-11.05-.05-2.39,1-3.26,3.31-3.22,4.52,.08,9.04,.02,13.56,0,1.58,0,3.15-.02,3.31,2.53,1.45-1.7,.74-3.25,1.06-4.6,1.65-.14,3.2,.34,4.78,.71,4.18,.98,4.19,.96,3.61,5.33-1.96,.01-3.91,.09-5.87,.02-2.27-.08-2.75,1.26-2.7,3.12-1.86,1.23-.1,3.83-1.92,5.07-1.1-.41-2.2-.82-3.3-1.22,.48-3.26,.64-6.41-2.96-8.19-2.39-1.33-4.74-1.66-7.01,.28-.3,.25-.6,.5-.9,.75-.52,.24-.86,.61-.92,1.2l-.06-.05c-1.86,1.81-.86,4.09-1.02,6.17,.12,2.16,.04,4.17-2.96,4.03-.07-.3-.1-.59-.08-.9Z"
            fill="#ebb740"
          />
          <path
            d="M324.98,155.31c4.46,1.09,6.8,3.96,7.24,8.49,.43,4.38-.87,8.03-4.78,10.29-4.02,2.32-8.05,1.95-11.82-.72-3.81-2.7-4.22-6.58-3.63-10.79,1.16,.65,.91,2.05,1.58,2.99,2.09,2.89,7.16,4.1,10.23,2.4,3.08-1.71,4.24-5.94,2.49-9.53-.5-1.03-1.33-1.89-1.31-3.13Z"
            fill="#9eafb3"
          />
          <path
            d="M318.97,179.57c5.81,2.73,8.28,7.48,6.6,12.69-1.58,4.9-6.6,8.1-11.62,7.41-4.58-.63-7.59-3.98-8.94-9.93,1.9-.39,3.05,.83,4.41,1.84,2.42,1.78,6.21,1.56,8.34-.24,3.08-2.6,3.72-5.48,2.19-8.86-.41-.9-2.2-1.44-.97-2.91Z"
            fill="#9eafb3"
          />
          <path
            d="M42.2,85.93c5.54,1.5,7.93,8.3,4.79,13.65-2.76,4.71-8.05,6.6-12.88,4.6-5.38-2.23-7.51-6.88-5.98-13.05,.56,.41,.74,1.01,.93,1.66,1.35,4.51,4.14,6.2,8.51,5.24,3.28-.72,6-4.74,5.51-8.27-.18-1.29-.59-2.55-.89-3.83Z"
            fill="#9eafb3"
          />
          <path
            d="M138.83,93.97c5,1.48,7.48,7.11,5.41,12.32-1.87,4.7-6.93,7.61-11.59,6.67-5.19-1.05-8.22-4.84-8.18-10.31,0-1.16,.19-2.32,.29-3.48,.57,.41,.74,1.01,.93,1.66,1.35,4.51,4.15,6.2,8.52,5.24,3.28-.72,6-4.74,5.51-8.28-.18-1.29-.58-2.55-.88-3.83Z"
            fill="#9eafb3"
          />
          <path
            d="M28.11,180.51c5.34,3.14,6.96,6.84,5.24,11.95-1.64,4.89-6.31,7.87-11.31,7.22-5.08-.66-8.6-4.95-9.01-10.97,1.9-.08,2.15,1.82,3.26,2.7,1.99,1.6,4,2.85,6.75,1.75,4.35-1.75,6.33-5.54,5.27-10.2-.18-.79-.13-1.63-.19-2.45Z"
            fill="#9eafb3"
          />
          <path
            d="M59.4,73.02c1.01,1.41,2.96,1.22,4.1,2.6,1.62,1.96,2.38,4.76,1.38,6.89-1.04,2.23-3.5,3.64-6.09,3.49-2.45-.14-4.76-1.96-5.47-4.34-.36-1.21,.37-2.74-1.09-3.62,1.54-2.88,3.79-4.75,7.16-5.02Z"
            fill="#e0e7ea"
          />
          <path
            d="M236.34,87.07c2.91,5.61,1.92,10.82-2.68,14.02-4.3,2.99-9.81,2.28-13.64-1.65-1.24-1.27-1.94-2.67-1.94-4.43,1.23,.05,2.13,.76,3.14,1.37,5.78,3.49,12.28,.33,13.18-6.41,.18-1.37,.07-2.74,1.94-2.9Z"
            fill="#889fa8"
          />
          <path
            d="M23.06,133.29c3.57,5.93,2.33,11.66-3.22,14.86-5.25,3.03-10.98,1.16-14.1-4.59,.73-1.03,1.46-.85,2.54-.35,6.09,2.83,11.15,.51,13.29-5.83,.46-1.37-.01-3.11,1.49-4.1Z"
            fill="#889fa8"
          />
          <path
            d="M275.82,73.02c1.48,1.26,3.54,1.64,4.77,3.34,1.81,2.51,1.54,4.8-1.11,7.45-2.7,2.69-4.99,2.85-7.86,.54-2.35-1.89-2.63-4.21-.89-7.02,.45-.72,1.91-1.08,.93-2.37,1.05-1.37,2.45-1.98,4.16-1.94Z"
            fill="#e0e7ea"
          />
          <path
            d="M30.21,110.07c2.68,3.64,2.17,8.15-1.35,11.43-5.49,5.13-14.98,3.1-16.85-4.27,.48,.11,1.02,.11,1.44,.33,6.95,3.63,12.49,1.71,15.51-5.46,.32-.77,.5-1.56,1.26-2.03Z"
            fill="#889fa8"
          />
          <path
            d="M326.12,109.08c2.94,5.83,1.18,11.57-4.37,14.28-5.33,2.6-10.88,.54-13.72-5.11,1.39-.15,2.66,.28,3.86,.88,2.86,1.43,5.43,.75,7.99-.84,2.22-1.38,3.82-3.09,4.53-5.71,.33-1.21,.37-2.72,1.71-3.5Z"
            fill="#889fa8"
          />
          <path
            d="M310.14,90.89c1.99,4.3,1.11,8.63-2.33,11.49-3.65,3.04-8.69,3.4-12.45,.69-1.72-1.24-3.55-2.56-3.71-5.02,.64,.15,1.35,.17,1.9,.48,6.47,3.6,11.23,1.5,14.52-5.63,.44-.96,1.15-1.58,2.08-2.02Z"
            fill="#889fa8"
          />
          <path
            d="M333.21,136.24c1.95,4.88,.56,9.23-3.78,11.81-4.11,2.45-9.72,1.7-12.78-1.76-1-1.13-1.8-2.39-2.04-3.92,1.46-.1,2.48,.77,3.58,1.55,2.23,1.58,4.47,1.74,7.02,.44,2.66-1.35,4.84-2.99,5.67-5.94,.36-1.27,.94-2.1,2.32-2.19Z"
            fill="#889fa8"
          />
          <path
            d="M156.27,81.62c-1.39,.55-2.85,.38-4.28,.44-1.56-.91-3.24-1.19-5.02-1.01,1.97-9.34,8.1-14.57,16.93-17.14,0,1.33,0,2.66,0,3.99-2.04,.19-3.76,1.25-5.38,2.3-3.05,1.98-4.96,4.73-4.64,8.62,.11,1.39,.7,2.12,2.14,2.05,.12,.24,.2,.49,.24,.75Z"
            fill="#fddf79"
          />
          <path
            d="M199.04,94.09c2.58,0,5.28-.82,7.43,1.57,1.31,1.46,2.21,2.9,1.47,4.88-.89,2.36-3.69,3.89-6.41,3.7-2.28-.16-3.63-1.37-4.33-3.44-.51-1.51,.59-3.37-1-4.65,.46-1.37,1.37-2.11,2.85-2.07Z"
            fill="#e0e7ea"
          />
          <path
            d="M159.82,35.87c-.94,3.89-1.03,7.78-.03,11.67-1.43,.97-2.28,2.62-3.95,3.29-4.39-6.36-4.33-11.63,.21-18.5,1.26,1.18,2.52,2.36,3.78,3.54Z"
            fill="#ebb740"
          />
          <path
            d="M174.49,69.17c-.36-1.84-.22-3.68,.07-5.52,2.11,.45,4.17,1.01,5.5,2.92-.12,1.92,.91,3.45,1.81,4.96,1.93,3.21,2.59,6.61,2.03,10.28-1.6-.02-3.21-.03-4.81-.04-.05-.29-.06-.59-.06-.89,.52-4.7-2.28-8.11-4.55-11.72Z"
            fill="#fddf79"
          />
          <path
            d="M179.16,47.57c1-3.91,.93-7.82-.03-11.73,1.25-1.18,2.5-2.37,3.75-3.55,.45,.69,.94,1.36,1.35,2.07,3.11,5.43,2.62,12.3-1.15,16.48-1.66-.67-2.51-2.31-3.92-3.28Z"
            fill="#ebb740"
          />
          <path
            d="M95.5,77.98c2.16,4.37,2.49,8.78-.7,12.7-3.92,4.82-10.7,4.46-15.51-.53,.73-1.1,1.63-.62,2.64-.44,6.48,1.12,11.42-2.43,12.61-8.9,.18-.97,.63-1.89,.95-2.83Z"
            fill="#889fa8"
          />
          <path
            d="M138.83,93.97c.3,1.28,.7,2.54,.88,3.83,.49,3.54-2.23,7.55-5.51,8.28-4.37,.96-7.17-.74-8.52-5.24-.2-.65-.36-1.25-.93-1.66,2.4-6.19,6.88-8.32,13.13-6.25-1.11,1.63,.45,.92,.98,1.11l-.02-.07Zm-2.03,4.9c-.09-2.82-1.75-4.75-4.08-4.74-2.18,0-4.9,2.67-4.97,4.85-.07,2.16,2.72,5.11,4.74,5.01,2.61-.12,4.4-2.25,4.31-5.13Z"
            fill="#bdcbd3"
          />
          <path
            d="M163.84,51.76c3.75,.39,7.49,1.32,11.25,.03,1.55,1.5,2.86,3.18,3.83,5.11-6.3,2.06-12.61,2.05-18.9-.02,.97-1.93,2.28-3.61,3.83-5.12Z"
            fill="#ebb740"
          />
          <path
            d="M42.2,85.93c.3,1.27,.71,2.54,.89,3.83,.49,3.53-2.23,7.55-5.51,8.27-4.37,.96-7.16-.73-8.51-5.24-.2-.65-.37-1.25-.93-1.66,.02-2.06,1.23-3.27,2.92-4.14,.03,1.49-.12,3.01,.11,4.48,.43,2.71,3.4,4.96,5.67,4.49,2.45-.5,3.92-3.39,3.25-6.38-.6-2.69-2.63-3.89-5.66-3.15-1.13,.28-2.2,.71-3.4,.58,3.71-3.53,6.49-4,10.9-1.83-.1,.1-.2,.21-.3,.31,.19,.18,.39,.35,.58,.53l-.03-.08Z"
            fill="#bdcbd3"
          />
          <path
            d="M28.11,180.51c.06,.82,.01,1.66,.19,2.45,1.07,4.67-.91,8.45-5.27,10.2-2.74,1.11-4.76-.15-6.75-1.75-1.1-.88-1.36-2.79-3.26-2.7-.24-2.61,.74-4.67,2.81-6.24l.17,.18c.04,1.32-.14,2.7,.18,3.94,.69,2.69,4.05,4.61,6.57,3.96,2.51-.65,3.88-3.35,3.22-6.37-.62-2.81-2.78-4.01-6.13-3.35-.96,.19-1.89,.54-2.84,.81l-.18-.17c2.96-3.03,6.31-3.99,10.22-1.88-.8,1.61,.62,.77,1.08,.98l-.02-.07Z"
            fill="#bdcbd3"
          />
          <path
            d="M318.97,179.57c-1.23,1.47,.56,2,.97,2.91,1.53,3.38,.89,6.26-2.19,8.86-2.13,1.8-5.91,2.03-8.34,.24-1.37-1.01-2.51-2.23-4.41-1.84-.22-1.17-.36-2.32,.69-3.22,.24,.17,.66,.5,.68,.48,.6-.71,.03-1.02-.5-1.34,.06-2.05,1.3-3.22,2.98-4.08,0,1.67-.08,3.35,.04,5.01,.17,2.29,1.5,3.67,3.75,4.03,1.77,.28,3.34-.18,4.42-1.72,1.27-1.81,1.45-3.96,.27-5.63-.97-1.37-2.48-2.9-4.61-2.42-1.29,.29-2.5,.95-3.89,.74,2.85-3.3,6.22-3.96,10.12-2.02Z"
            fill="#bdcbd3"
          />
          <path
            d="M181.04,117.33c-.05-1.86,.44-3.2,2.7-3.12,1.95,.07,3.91,0,5.87-.02-.13,1.92-.26,3.85-.4,5.77-.11,1.85-.21,3.7-.31,5.54q-7.84-.46-7.86-8.17Z"
            fill="#f7c942"
          />
          <path
            d="M324.98,155.31c-.02,1.24,.81,2.1,1.31,3.13,1.75,3.59,.59,7.81-2.49,9.53-3.07,1.71-8.13,.49-10.23-2.4-.67-.93-.42-2.33-1.58-2.99,.43-3.02,1.63-5.43,4.93-6.16,.15,1.51-1.14,2.36-1.62,3.56-.87,2.18,.17,4.4,2.6,5.87,1.97,1.19,3.78,.74,5.69-1.43,1.82-2.06,1.74-3.61,.13-5.77-1.8-2.42-4.32-2.18-6.81-2.22,2.43-2.27,5.1-2.8,8.08-1.13Z"
            fill="#bdcbd3"
          />
          <path
            d="M95.5,77.98c-.32,.94-.77,1.86-.95,2.83-1.19,6.46-6.13,10.02-12.61,8.9-1.02-.18-1.91-.66-2.64,.44-2.68-2.98-2.39-6.5-1.83-10.07,.57,.42,.72,1.02,.91,1.67,1.33,4.49,4.21,6.29,8.54,5.19,2.82-.71,4.46-2.91,5.2-5.52,.59-2.06-.1-3.93-2.57-4.53-.34-.34-.68-.68-1.02-1.02,.01-.84,.24-1.56,.99-2.04,2.85,.15,4.72,1.72,5.98,4.15Z"
            fill="#9eafb3"
          />
          <path
            d="M175.02,31.69c-3.7,0-7.41,0-11.11,.02-1.14-1.25-2.26-2.53-2.92-4.12,1.47-1.63,3.4-1.85,5.47-1.94,4.04-.17,7.99,.25,11.89,1.24-.71,1.88-2.07,3.32-3.34,4.81Z"
            fill="#f7c942"
          />
          <path
            d="M254.58,73.87c-.88,.88-.14,1.46,.42,2.02,2.2,2.22,2.23,4.86,.73,7.23-1.61,2.54-3.89,4.63-7.37,3.88-2.85-.62-4.6-2.41-4.97-5.38-.09-.7-.43-1.23-.95-1.66,2.06-5.93,6.29-8.05,12.14-6.07Zm-5.28,11.1c2.1,.12,4.97-2.42,5.19-4.59,.23-2.33-1.75-4.36-4.33-4.44-2.59-.08-4.49,1.58-4.7,4.11-.21,2.58,1.51,4.79,3.84,4.93Z"
            fill="#bdcbd3"
          />
          <path
            d="M333.21,136.24c-1.38,.09-1.96,.92-2.32,2.19-.84,2.95-3.02,4.58-5.67,5.94-2.55,1.3-4.79,1.15-7.02-.44-1.1-.78-2.12-1.65-3.58-1.55-1.29-1.87-.65-3.92-.55-5.93,1.19,1.37,2.29,2.84,3.6,4.1,2.65,2.53,5.76,2.56,8.44,.24,3.37-2.92,3.91-5.79,1.75-9.15-.47-.72-1.87-1.14-.83-2.39,2.53,.55,4.67,1.62,5.69,4.21-.07,.1-.23,.25-.2,.29,.11,.19,.28,.35,.43,.52,.09,.66,.18,1.31,.27,1.97Z"
            fill="#9eafb3"
          />
          <path
            d="M236.34,87.07c-1.87,.16-1.75,1.53-1.94,2.9-.9,6.74-7.4,9.9-13.18,6.41-1.01-.61-1.91-1.32-3.14-1.37-1.26-2.35-.97-4.63,.32-6.86,1.55,.9,.09,3.91,2.8,4,.34,.34,.69,.69,1.03,1.03,.18,1.74,1.11,2.74,2.88,2.86,3.06,.22,6.97-3.24,7.3-6.34,.48-4.47-2.79-5.93-5.91-7.54,4.33-.47,7.71,.95,9.83,4.91Z"
            fill="#9eafb3"
          />
          <path
            d="M30.21,110.07c-.76,.47-.94,1.26-1.26,2.03-3.01,7.17-8.55,9.09-15.51,5.46-.42-.22-.96-.23-1.44-.33-1.48-2.33-1.23-4.65,.02-6.98,.99,.64,.71,1.76,1.04,2.66,1.27,3.47,4.61,5.11,8.43,4.25,2.92-.66,4.54-3.21,4.63-6.74,.06-2.45-1.05-3.94-2.92-5.35-.92-.7,.45-.7,.86-.96,3.25,.75,6.01,2.02,6.15,5.97Z"
            fill="#9eafb3"
          />
          <path
            d="M24.06,104.09c-.4,.26-1.78,.27-.86,.96,1.87,1.41,2.98,2.9,2.92,5.35-.09,3.53-1.71,6.08-4.63,6.74-3.81,.86-7.15-.78-8.43-4.25-.33-.9-.06-2.02-1.04-2.66,2.29-5.57,6.82-7.88,12.04-6.15Zm-9.09,6.32c-.13,2.83,1.73,4.8,4.53,4.79,2.6,0,4.41-1.71,4.54-4.3,.12-2.61-1.5-4.53-4.03-4.77-2.81-.27-4.91,1.51-5.04,4.28Z"
            fill="#bdcbd3"
          />
          <path
            d="M308.07,109.33c3.52-5.55,6.82-6.99,11.92-5.22-.42,.13-1,.04-1.08,.65-.01,.08,.45,.3,.71,.33,.47,.06,.95,.02,1.43,.02,0,0-.05-.05-.05-.05,.18,1.98,1.26,3.77,1.02,5.87-.41,3.66-2.55,6.09-5.84,6.31-4.27,.28-6.56-1.46-7.3-5.64-.14-.82-.09-1.66-.81-2.26Zm7.39,5.87c2.61-.02,4.4-1.73,4.51-4.32,.12-2.82-1.76-4.78-4.57-4.76-2.61,.01-4.4,1.73-4.5,4.32-.12,2.83,1.76,4.78,4.56,4.76Z"
            fill="#bdcbd3"
          />
          <path
            d="M308.07,109.33c.72,.59,.67,1.44,.81,2.26,.74,4.18,3.03,5.93,7.3,5.64,3.28-.22,5.43-2.65,5.84-6.31,.23-2.1-.84-3.89-1.02-5.87,2.37,.5,4.49,1.31,5.13,4.02-1.34,.78-1.38,2.29-1.71,3.5-.72,2.62-2.31,4.33-4.53,5.71-2.56,1.59-5.12,2.27-7.99,.84-1.2-.6-2.48-1.03-3.86-.88-1.63-2.98-1.39-5.95,.04-8.91Z"
            fill="#9eafb3"
          />
          <path
            d="M5.05,135.45c2.7-5.82,6.64-7.9,11.95-6.29-.04,1.26,.84,2.11,1.34,3.15,1.7,3.5,.87,7.03-1.94,8.84-3.21,2.07-5.81,1.48-8.83-1.5-1.26-1.25-1.27-3.05-2.52-4.19Zm11.96,.2c-.07-2.61-1.82-4.34-4.43-4.38-2.61-.05-4.68,1.82-4.61,4.17,.06,2.17,2.75,4.84,4.92,4.87,2.36,.04,4.19-2.04,4.12-4.66Z"
            fill="#bdcbd3"
          />
          <path
            d="M109.76,82.18c2.49,1.29,5.25,2.32,5.86,5.57,.59,3.17-2.1,7.39-5.19,8.22-2.72,.72-6.44-1.65-7.76-5.04-.35-.9,.02-2.05-.98-2.72,1.65-3.4,4.11-5.71,8.07-6.03Zm3.83,6.69c-.1-2.35-2.31-4.1-4.91-3.89-2.39,.19-4.18,2.04-4.08,4.22,.1,2.35,2.31,4.1,4.91,3.89,2.39-.19,4.18-2.04,4.08-4.22Z"
            fill="#bdcbd3"
          />
          <path
            d="M290.88,92.15c2.12-7.26,6.93-9.73,14.06-7.21-.95,.41-1.62,1.09-2.02,2.04-1.37-.58-2.74-1.15-4.3-.93-2.03,.29-4.53,2.62-4.73,4.51-.27,2.57,1.52,3.94,3.35,5.06,1.76,1.08,3.75,.13,5.55-1.96,1.5-1.74,.88-3.77,1.13-5.69,.46,.18,1.16,.22,1.33,.55,1.49,2.88,.65,5.53-2.46,8.13-2.3,1.92-5.45,2.13-7.62,.21-1.58-1.4-2.87-3.13-4.29-4.71Z"
            fill="#bdcbd3"
          />
          <path
            d="M282.75,222.76c1.18-3.62,2.29-4.27,6.9-4.05,1.57,3.8,2.24,7.58-.4,11.24-4.99-.72-6.18-2.04-6.5-7.18Z"
            fill="#bdcbd3"
          />
          <path
            d="M5.05,135.45c1.25,1.14,1.26,2.94,2.52,4.19,3.02,2.99,5.62,3.57,8.83,1.5,2.81-1.81,3.64-5.34,1.94-8.84-.5-1.03-1.38-1.89-1.34-3.15,2.85,.16,4.77,1.67,6.06,4.13-1.5,.99-1.03,2.73-1.49,4.1-2.13,6.33-7.19,8.66-13.29,5.83-1.08-.5-1.81-.68-2.54,.35-1.82-2.56-1.9-5.28-.69-8.1Z"
            fill="#9eafb3"
          />
          <path
            d="M327.03,129.26c-1.05,1.25,.36,1.67,.83,2.39,2.16,3.35,1.62,6.22-1.75,9.15-2.68,2.32-5.79,2.29-8.44-.24-1.31-1.25-2.41-2.72-3.6-4.1,.34-2.44,1.39-4.35,3.87-5.19-.29,1.11-.69,2.21-.85,3.34-.28,2.04,1.48,4.7,3.52,5.46,2.03,.76,3.47-.21,4.84-1.6,1.43-1.45,2.04-3.02,1.08-4.93-1.1-2.2-3.23-3.17-5.68-2.7-.97,.18-1.95,.29-2.92,.43,2.5-3.11,5.51-3.9,9.11-2.02Z"
            fill="#bdcbd3"
          />
          <path
            d="M89.55,76.88c2.47,.59,3.16,2.47,2.57,4.53-.74,2.61-2.38,4.81-5.2,5.52-4.34,1.1-7.21-.7-8.54-5.19-.19-.65-.35-1.26-.91-1.67,2.25-5.78,6.54-8,12.06-6.25-.75,.48-.98,1.21-.99,2.04-2.61-.7-5.11-1.32-7.08,1.49-1.31,1.88-1.46,3.7-.4,5.57,1.01,1.78,2.76,2.37,4.73,2.02,2.23-.4,3.5-1.8,3.67-4.08,.1-1.32,.07-2.66,.09-3.99Z"
            fill="#bdcbd3"
          />
          <path
            d="M49.28,218.72c3.64-.92,5.68,.88,6.91,4.06-.31,5.14-1.51,6.46-6.52,7.15-2.63-3.65-1.91-7.42-.39-11.21Z"
            fill="#bdcbd3"
          />
          <path
            d="M302.91,86.98c.4-.95,1.07-1.63,2.02-2.04,2.89,.98,4.97,2.66,5.21,5.95-.92,.43-1.64,1.06-2.08,2.02-3.29,7.13-8.05,9.23-14.52,5.63-.55-.31-1.26-.33-1.9-.48-1.32-1.83-.88-3.89-.76-5.91,1.42,1.58,2.71,3.31,4.29,4.71,2.17,1.92,5.32,1.72,7.62-.21,3.11-2.59,3.95-5.24,2.46-8.13-.17-.32-.87-.37-1.33-.55-.34-.33-.67-.67-1.01-1Z"
            fill="#9eafb3"
          />
          <path
            d="M178.36,26.88c-3.9-.99-7.86-1.41-11.89-1.24-2.07,.09-3.99,.31-5.47,1.94-1.38-1-2.32-2.3-2.78-3.95,3.39-1.06,16.76-1.23,22.38-.29,.05,1.69-1.19,2.55-2.23,3.54Z"
            fill="#ebb740"
          />
          <path
            d="M283.7,190.52c4.7,1.52,9.2,3.69,14.17,4.3,.05,.25,.06,.51,.02,.76-3.47,.51-6.55-.98-9.72-1.93-1.9-.57-3.79-1.2-5.59-1.77-1.28,1.23-.47,2.29-.13,3.36,1.27,3.97,2.66,7.91,3.76,11.93,.64,2.35,1.49,4.97-1.48,6.62,0,0,.03,.05,.03,.05,.72-3.31,.23-6.47-.93-9.63-1.25-3.39-2.27-6.88-3.33-10.34-1.22-3.96-1.14-4.02,3.22-3.34Z"
            fill="#f8dbb2"
          />
          <path
            d="M258.53,285.33c5.31-.07,10.63-.13,15.94-.2-.56,1.33-1.07,2.67-.65,4.16-.79,.13-1.59,.26-2.38,.39-4.29-.11-8.58-.23-12.87-.34-.01-1.34-.02-2.67-.03-4.01Z"
            fill="#c68f43"
          />
          <path
            d="M64.45,285.15c5.32,.06,10.64,.13,15.96,.19-1.14,1.09-2.44,2.1-1.97,3.99-2.96,.12-5.93,.23-8.89,.35-1.68-.39-3.59,.06-4.99-1.34-.04-1.06-.07-2.12-.11-3.19Z"
            fill="#c68f43"
          />
          <path
            d="M41.07,194.86c5.04-.43,9.44-2.94,14.18-4.35,1.44,.1,4.57-1.99,3.63,1.53-1.44,5.35-2.54,10.93-5.69,15.71-.07-3.94,1.99-7.36,2.72-11.1,.28-1.43,1.25-2.72,.9-4.62-5.41,.58-10.16,4.14-15.76,3.51-.05-.23-.04-.45,.02-.68Z"
            fill="#f8dbb2"
          />
          <path
            d="M156.05,32.33c-4.54,6.87-4.6,12.14-.21,18.5-.85,1.41-1.9,2.58-3.81,3.52V28.47c2.12,.55,2.99,2.3,4.02,3.87Z"
            fill="#c68f43"
          />
          <path
            d="M183.08,50.84c3.78-4.18,4.26-11.05,1.15-16.48-.41-.71-.9-1.38-1.35-2.07,.86-1.61,2.02-2.93,3.98-4.24v26.29c-1.88-.9-2.91-2.1-3.78-3.49Z"
            fill="#c68f43"
          />
          <path
            d="M282.75,222.76c.32,5.14,1.51,6.46,6.5,7.18-1.21,2.92-3.62,4.25-6.52,4.93-2.89-3.66-2.89-7.34,.02-12.12Z"
            fill="#889fa8"
          />
          <path
            d="M226.51,82.16c3.12,1.61,6.39,3.07,5.91,7.54-.33,3.11-4.23,6.56-7.3,6.34-1.77-.13-2.7-1.12-2.88-2.87,.81,.18,1.63,.29,2.42,.54,2.78,.88,4.04-1.22,5.2-2.93,1.2-1.77,.27-3.39-1.05-4.94-1.82-2.14-4.16-1.8-6.47-1.83l-.1-.1c1.17-1.21,2.54-1.91,4.27-1.75Z"
            fill="#bdcbd3"
          />
          <path
            d="M49.67,229.94c5.01-.7,6.21-2.02,6.52-7.15,2.45,4.04,3.56,8.09,0,12.13-2.83-.8-5.39-1.95-6.52-4.98Z"
            fill="#889fa8"
          />
          <path
            d="M280.75,276.97c-2.8,.06-5.63-.12-8.39,.23-4.76,.61-8.34-.92-10.82-5.03,1.9-.49,3.55,.26,5.23,.98,4.42,1.9,8.94,3.38,13.85,3.08,.18,.22,.22,.47,.12,.74Z"
            fill="#f8dbb2"
          />
          <path
            d="M77.42,272.17c-2.53,3.99-6.01,5.7-10.82,5.04-2.75-.38-5.58-.17-8.38-.22-.09-.31-.05-.6,.14-.87,.62-.1,1.23-.21,1.85-.31,4.21,.96,7.76-1.19,11.48-2.46,1.88-.64,3.61-1.75,5.72-1.18Z"
            fill="#f8dbb2"
          />
          <path
            d="M63.54,269.4c2.87-.55,5.73-.06,8.65,.24-3.74,1.06-6.89,3.76-11.01,3.53,.78-1.26,1.57-2.51,2.35-3.77Z"
            fill="#d12438"
          />
          <path
            d="M277.87,273.2c-4.1,.18-7.34-2.35-11.06-3.57,2.86-.27,5.67-.77,8.51-.22,.85,1.26,1.7,2.53,2.55,3.79Z"
            fill="#d12438"
          />
          <path
            d="M221.2,92.15c-2.72-.09-1.26-3.1-2.8-4,.66-1.98,1.43-3.85,3.84-4.24,0,0,.1,.1,.1,.1-.93,2.64-1.17,5.37-1.13,8.14Z"
            fill="#bdcbd3"
          />
          <path
            d="M8.92,159.48c-.27,.04-.54,.08-.82,.1,.65-1.8,1.77-3.04,3.83-3.11,0,0,.05-.05,.05-.05-.62,1.42-1.62,2.46-3.05,3.07Z"
            fill="#bdcbd3"
          />
          <path d="M27.99,143.27c0,2.07,0,4.14,0,6.22-.88-2.07-.9-4.14,0-6.22Z" fill="#ebb740" />
          <path
            d="M60.22,275.81c-.62,.1-1.23,.21-1.85,.31,.38-.9,1.04-1.54,1.9-1.98-.02,.56-.04,1.11-.05,1.67Z"
            fill="#d12438"
          />
          <path
            d="M321.05,105.11c-.48,0-.96,.04-1.43-.02-.26-.03-.72-.25-.71-.33,.08-.61,.65-.52,1.08-.65,.35,.33,.71,.67,1.06,1Z"
            fill="#9eafb3"
          />
          <path
            d="M40.98,195.61c-.46,.7-.92,1.39-1.38,2.09-1.01-1.66,.11-1.92,1.38-2.09Z"
            fill="#f8dbb2"
          />
          <path
            d="M305.89,185.65c.52,.32,1.1,.63,.5,1.34-.02,.02-.44-.31-.68-.48,.06-.29,.12-.58,.18-.86Z"
            fill="#9eafb3"
          />
          <path
            d="M190.08,91.05c.46-.89,1.28-1,2.15-1-.06,.32-.12,.65-.18,.97-.66,0-1.32,.02-1.97,.03Z"
            fill="#ebb740"
          />
          <path
            d="M138.86,94.04c-.52-.2-2.09,.52-.98-1.11,.33,.37,.65,.74,.98,1.11Z"
            fill="#9eafb3"
          />
          <path
            d="M306.94,170.07c-.01-1.01-.03-2.02,1.08-2.56-.02,.99-.21,1.92-1.08,2.56Z"
            fill="#c68f43"
          />
          <path
            d="M28.13,180.58c-.46-.22-1.89,.62-1.08-.98,.36,.33,.72,.66,1.08,.98Z"
            fill="#9eafb3"
          />
          <path
            d="M15.84,182.47c.33-.33,.66-.66,.99-.99,0,0,.18,.17,.18,.17-.33,.33-.67,.67-1,1,0,0-.17-.18-.17-.18Z"
            fill="#bdcbd3"
          />
          <path d="M298.95,196.23c-.55,.18-.88-.01-1-.58,.33,.19,.67,.39,1,.58Z" fill="#f8dbb2" />
          <path
            d="M332.94,134.27c-.15-.17-.31-.33-.43-.52-.03-.04,.13-.19,.2-.29,.23,.23,.3,.5,.23,.81Z"
            fill="#889fa8"
          />
          <path
            d="M42.23,86.01c-.19-.18-.39-.35-.58-.53,.1-.11,.2-.21,.3-.31,.14,.26,.24,.54,.29,.84Z"
            fill="#9eafb3"
          />
          <path
            d="M61.29,273.11c-.36,.37-.72,.73-1.07,1.1,.14-.58,.47-.97,1.07-1.1Z"
            fill="#d12438"
          />
          <path
            d="M242.44,79.96c-.27,.36-.53,.72-.8,1.08-.02-.57,.26-.92,.8-1.08Z"
            fill="#bdcbd3"
          />
          <path
            d="M44.67,113.19c.48-3.02,2.88-3.67,5.3-4.28,1.99,.48,2.31-.83,2.48-2.3,1.13-.33,2.27-.66,3.41-.98,1.43,.73,2.18,.09,2.57-1.27,.3-.04,.6-.1,.9-.17,6.27-.39,12.49-1.62,18.81-1.05,1.11,.1,2.5-.28,3.01,1.13,.54,1.51-1.22,1.74-1.76,2.68-2.36,0-4.72,0-7.08,0-1.72-1.25-3.2-1.28-4.22,.87-.59,.04-1.19,.09-1.78,.13-2.33-.93-4.03-.16-5.23,1.95-2.14,.8-4.45,1.36-5.29,3.9-.52,.11-1.03,.22-1.55,.33-.23-.21-.59-.66-.67-.61-3.09,1.77-6.38,3.4-6.29,7.75-.87,2.64-2.57,4.81-4.03,7.11-2.17-.13-3.38-.64-2.56-3.39,.86-2.9,1.7-5.73,3.47-8.2,.81-1.12,1.58-2.21,.53-3.59Z"
            fill="#fffefe"
          />
          <path
            d="M83.23,101.38c4.6,.3,8.71,2.35,12.75,4.18,11.86,5.36,23.81,10.5,35.89,15.34,.58,.23,1.29,.47,1.31,1.72-3.28,.19-6.28-1.15-9.33-1.88-13.12-3.13-25.7-8.25-39.01-10.71-.95-.18-1.35-.89-1.6-1.73,.82-.06,1.65-.15,2.47-.18,1.35-.04,2.87-.03,3.27-1.59,.44-1.7-1.21-2.07-2.29-2.75-1.2-.74-3.06-.52-3.46-2.41Z"
            fill="#fddf79"
          />
          <path
            d="M41.03,136.19c.68,3.55-.9,6.88-1.04,10.39-.21,5.46-.18,10.88,.06,16.32,.07,1.49,.96,3.91-1.28,4.25-2.07,.32-2.12-2.04-2.66-3.58-2.71-7.67-3.51-15.58-2.99-23.63,.47-7.22,2.62-14.03,5.49-20.63,.47-1.09,1.08-2.1,2.45-2.24,.16,1.23-.42,2.26-.99,3.26-1.8,3.2-2.69,6.71-3.52,10.24-1.05,4.46-.26,5.41,4.48,5.61Z"
            fill="#fddf79"
          />
          <path
            d="M83.23,101.38c.4,1.89,2.26,1.67,3.46,2.41,1.09,.67,2.73,1.04,2.29,2.75-.4,1.56-1.93,1.54-3.27,1.59-.82,.03-1.64,.12-2.47,.18-1.26-.03-2.52-.07-3.79-.11-.02-.41-.05-.82-.07-1.24,.54-.94,2.3-1.17,1.76-2.68-.5-1.41-1.89-1.03-3.01-1.13-6.32-.58-12.54,.66-18.81,1.05,.67-.69,1.33-1.39,2-2.08,1.15-.09,2.34-.03,3.44-.3,5.15-1.28,10.28-2.17,15.53-.48,.89,.29,1.95,.05,2.93,.05Z"
            fill="#f8dbb2"
          />
          <path
            d="M41.03,136.19c-4.74-.2-5.53-1.15-4.48-5.61,.83-3.53,1.71-7.04,3.52-10.24,.56-1,1.15-2.03,.99-3.26,.45-1.99,2.25-2.73,3.6-3.89,1.06,1.38,.29,2.47-.52,3.59-1.78,2.47-2.61,5.31-3.47,8.2-.82,2.75,.39,3.26,2.56,3.39-.1,1.25-.2,2.49-.3,3.74-1.25,.32-1.87,1.07-1.64,2.4-.09,.56-.17,1.11-.26,1.67Z"
            fill="#f8dbb2"
          />
          <path
            d="M151.1,133.21c-.07-.34-.14-.67-.22-1.01-.01-1.48-.05-2.96-.03-4.43,.05-4.67,.56-5.19,5.41-5.53,.49-.03,.98-.01,1.48-.02,.62,3.03-.82,6.25,.88,9.17-.02,.6-.04,1.2-.07,1.8-2.48,0-4.97,0-7.45,.01Z"
            fill="#f7c942"
          />
          <path
            d="M66.3,107.94c.59-.04,1.19-.09,1.79-.12,.8,.15,1.6,.3,2.41,.44-.22,.44-.38,1.24-.66,1.28-4.64,.69-8.73,2.96-13.09,4.45-.27,.09-.64-.11-.97-.18,.85-2.55,3.15-3.11,5.29-3.9,1.99,.01,3.83-.39,5.23-1.95Z"
            fill="#fddf79"
          />
          <path
            d="M47.26,121.26c-.09-4.35,3.2-5.98,6.29-7.75,.08-.05,.44,.4,.67,.61-1.74,2.95-4.17,5.22-6.96,7.14Z"
            fill="#f8dbb2"
          />
          <path
            d="M158.62,131.39c-1.71-2.92-.27-6.15-.88-9.17,.34-1.27-.29-2.78,.98-3.81,.58,1.98-.49,4.29,1.2,6.05-.02,.31,0,.6,.08,.9-.07,1.65-.13,3.3-.19,4.95-.39,.36-.79,.72-1.18,1.08Z"
            fill="#fddf79"
          />
          <path
            d="M79.38,106.95c.02,.41,.05,.82,.07,1.24-2.39,1.49-4.79,1.5-7.18,0,.01-.42,.02-.83,.03-1.25,2.36,0,4.72,0,7.08,0Z"
            fill="#fddf79"
          />
          <path
            d="M72.3,106.95c-.01,.41-.02,.83-.03,1.25-.6,.02-1.19,.04-1.78,.06-.8-.15-1.6-.29-2.4-.44,1.02-2.15,2.5-2.12,4.22-.87Z"
            fill="#f8dbb2"
          />
          <path
            d="M52.45,106.61c-.17,1.47-.49,2.78-2.48,2.3,.16-1.48,.3-2.99,2.48-2.3Z"
            fill="#f8dbb2"
          />
          <path
            d="M61.32,102.11c-.67,.69-1.33,1.39-2,2.08-.3,.07-.6,.13-.9,.17-.46-.14-.92-.28-1.37-.41,.67-2.37,2.62-1.76,4.27-1.83Z"
            fill="#fddf79"
          />
          <path
            d="M57.05,103.94c.46,.14,.91,.27,1.37,.41-.39,1.36-1.14,2.01-2.57,1.27,.16-.74,.59-1.28,1.2-1.69Z"
            fill="#f8dbb2"
          />
          <path
            d="M41.29,134.52c-.23-1.33,.39-2.08,1.64-2.4,.3,1.38-.38,2.08-1.64,2.4Z"
            fill="#fddf79"
          />
          <path
            d="M52.15,181.68c1.68-5.59,3.32-11.18,5.05-16.75,.99-3.19,2.18-6.31,3.17-9.5,1.53-4.9,4.84-7.64,9.73-9.13,10.63-3.24,21.34-3.82,32.18-1.56,1.95,.41,3.53,.21,5.29-.49,13.86-5.53,28.39-7.26,43.18-7.48,0,0-.08,.3-.08,.3,0,0,.22,.22,.22,.22,.1,4.03,.19,8.06,.29,12.09-.18,4.68-.35,9.35-.53,14.03-1.55,4.24-.42,8.77-1.45,13.07-.17,1.98-.34,3.96-.51,5.94-1.63,.97-.4,1.54,.31,2.18,3.61,4.44,7.68,8.43,12.06,12.11,.27,.41,.54,.81,.81,1.22,0,.78,.02,1.56,.02,2.33-.34,.49-.68,.98-1.01,1.48l.05-.08c-2.37,1.51-4.3,.69-6.37-.87-3.51-2.65-6.89-5.56-11-7.8-1.1,9.36-.69,35.61,.55,38.67,1.33-.51,2.1-1.56,2.71-2.77,1.83-1.64,4.08-2.8,5.44-5,.7-1.13,1.97-1.76,3.23-2.29,4.32-1.83,7.19-.02,7.53,4.64,.25,3.45-.74,6.58-2.06,9.67-9.45,11.8-21.59,13.6-34,5.05-.67-.47-1.25-1.14-2.19-1.04h0c.02-.7-.32-1.04-1.02-1.01h.01c-.75-2.15-2.06-3.87-4.05-5.03l.03,.06c.19-1.05-.36-1.76-1.11-2.38,.07-.19,.05-.36-.06-.53,.08-.8-.14-1.49-.73-2.05,.11-.22,.12-.44,.03-.67,2.32-.97,3.19-2.79,2.59-5.12-.6-2.33-2.31-3.44-4.74-3.38-.53-1.57,.84-2.45,1.31-3.67,2.46-1.03,5-1.55,7.67-1.31,.42,.75,1.15,.96,1.92,1.09,.99,1.32,1.97,2.65,2.96,3.97,.3,.93-.27,2.58,1.37,2.45,.96-.08,1.04-1.39,1.02-2.35l-.12-.02c1.14-.33,.88-1.32,1-2.13l-.04,.1c3.6-5.55,4.03-11.56,2.02-17.65-2.24-6.79-8.39-9.09-14.86-5.98-1.49,.72-2.57,2.18-4.34,2.37l.07,.1c-.59-2.82,.34-5.55,.53-8.32,.57-8.39-2.16-15.46-8.57-21.01-.16-1.38-.91-2.32-2.15-2.89-.34-.98-1.08-1.58-1.99-1.99l-.05-.06c-.32-.27-.63-.55-.95-.82l-.25-.19c-.04-.32-.22-.49-.53-.51-2.77-1.33-3.14,1.16-4.18,2.61-1.68,1.65-2.69,3.64-3.1,5.95-.78,.45-.97,1.2-1.03,2.01l.05-.09c-.81,.47-.95,1.26-1.02,2.09l.02-.05c-3.08,5.6-3.02,11.38-.99,17.27-.34,2.98,1.43,5.37,2.19,8.05-.38,.33-.75,.66-1.13,.99-.9-.71-1.72-1.56-2.71-2.1-4.84-2.64-9.2-1.16-11.37,3.84-1,2.31-1.4,4.74-.82,7.25,.32,3.68,.99,7.24,3.75,10,.06,1.44,.94,2.34,2.04,3.11,.37,1.18,1.32,1.9,2.19,2.64,2.19,1.87,3.17,1.65,3.48-1.23,.3-2.71,1.57-4.62,3.34-6.41,1.02-.03,2.04-.05,3.05-.08l-.07-.04c.52,.69,1.27,.9,2.07,.98,0,0,0,0,0,0q2.22,2.65-.56,4.42c-.25,.16-.39,.51-.58,.77-2.72,4.58-1.7,6.51,4.17,7.85-.23,1.42-2.08,2.39-1.18,4.13-.22,.33-.44,.66-.66,.99-2.2,.97-3.37,3.09-5.17,4.54-6.98,5.61-14.55,7.09-22.79,3.21-4.08-1.92-7.13-4.85-7.58-9.7,.37-.35,.75-.69,1.13-1.04,4.06-1.18,6.59,2.25,9.92,3.28,.97,.55,2.13,1,1.71-.81-1.09-4.73-2.22-9.45-3.64-14.09-2.09-6.86-3.07-14.03-5.96-20.66-1.23-1.34-1.65,0-1.94,.73-.98,2.43-1.77,4.92-2.7,7.37-1.29,3.38-3.46,5.52-7.4,4.98,0,0,0,.04,0,.04-.4-1.67-.79-3.34-1.19-5.02,.03-.35,.06-.71,.1-1.06,3.15-4.78,4.25-10.36,5.69-15.71,.95-3.52-2.19-1.43-3.63-1.53-1.65-2.73-2.87-5.61-3.11-8.83Z"
            fill="#d12438"
          />
          <path
            d="M161.03,196.72c-4.38-3.68-8.45-7.67-12.06-12.11,5.85,0,11.7-.08,17.54,.01,7.68,.13,15.36-.43,23.03,.27-2.82,3.91-6.51,6.99-9.93,10.33-1.5,1.47-2.62,2.93-2.53,5.1,.1,.64,.38,1.16,1,1.43l-.06-.07c.36,.35,.72,.69,1.08,1.04l-.02-.07c-.01,1.14,.47,1.89,1.66,2.07,2.05,.31,3.97-.07,5.74-1.13,1.92-1.15,3.82-2.35,5.86-3.6,.33,.72,.7,1.14,.7,1.57,.01,9.46-.01,18.91-.03,28.37-1.62-.92-2.77-2.37-3.89-3.79-1.36-1.73-2.98-3.13-4.87-4.17-4.7-2.6-8.16-.56-8.43,4.77-.14,2.72,.87,5.2,1.26,7.81-.03,.96-.06,1.91,1.03,2.38l-.02-.06c.8,5.83,5.16,8.97,9.82,10.79,7.23,2.81,14.57,2.12,21.45-2.09,2.6-1.59,4.33-4.12,6.94-5.63,.64,1.35,1.29,2.71,1.93,4.06-.08,.53-.16,1.07-.24,1.6-1.31,.24-2.67,.41-2.98,2.08-1.33,.21-2.69,.38-2.98,2.08-1.39,.15-2.73,.37-2.96,2.13-1.2-.04-2.4,.11-3.13,1.14-.81,1.15-1.39,2.43,.82,2.78,.59,1.92,1.63,3.25,3.88,3.22,4.01-.06,8.09,.39,12.03-.18,8.01-1.16,15.99-.71,23.99-.42-.51,1.31-1.57,1.58-2.83,1.57-2.17-.02-4.34,.04-6.51,.02-1.43-.01-2.68,.19-3.16,1.8-17.9,.05-35.81,.31-53.71,0-5.14-.09-10.34-1-15.48-.58-18.04,1.48-36.1,.38-54.14,.58-.84-2.44-2.95-1.56-4.65-1.8-3.2-.46-6.62,1.07-9.62-1.09,6.39-1.68,12.9-.98,19.28-.41,4,.36,7.97,.26,11.94,.52,2.38,.16,3.78-.95,4.37-3.2,2.79-.58,1.63-2.18,.51-3.08-1.65-1.34-3.53-2.49-5.7-2.94-.06-.33-.11-.66-.16-1-.04-1.6-.08-3.21-.12-4.81,3.61,1.92,6.91,4.14,11.26,4.77,9.82,1.43,16.72-1.65,22.41-8.97,.76-.97,2.32-2.33,.58-3.89,1.32-3.09,2.31-6.22,2.06-9.67-.34-4.66-3.2-6.47-7.53-4.64-1.25,.53-2.52,1.16-3.23,2.29-1.37,2.2-3.61,3.36-5.44,5-.73-.55-.99-1.32-.99-2.19,.02-8.05,.03-16.09,.06-24.14,0-.73,.39-1.24,1.37-1.48,2.27,1.77,5.04,2.96,8,3.58,3.2,.68,4.24,.04,5.67-3,0,0-.05,.08-.05,.08,.63-.29,.91-.82,1.01-1.48,0-.78-.02-1.56-.02-2.33-.27-.41-.54-.81-.81-1.22Zm19,53.34c-.72-2.49-2.7-3.46-4.96-4.1-.05-2.14-1.89-3.03-3.07-4.36-1.68-1.9-3.4-1.84-5.11,0-.9,.97-2.04,1.78-2.05,3.3-3.11,.41-5.14,2.07-5.93,5.16-2.69-.28-4.23,1.46-5.5,3.38-.6,.9,.26,1.41,1.2,1.47,.4,1.83,1.67,2.24,3.35,2.23,7.66-.03,15.31-.03,22.97,0,1.66,0,2.97-.34,3.36-2.2,1.26-.16,1.87-.83,.99-1.91-1.34-1.64-2.76-3.3-5.25-2.98Zm-17.08-43.56c-2.54,2.68-2.58,5.67-.82,8.68,1.7,2.9,4.28,4.77,7.76,4.52,3.63-.27,6.08-2.43,7.51-5.73,1.45-3.36,.29-6.33-1.98-8.68-2.62-2.71-5.88-3.6-9.46-1.57-1.39,.51-2.16,1.68-3,2.79Z"
            fill="#fddf79"
          />
          <path
            d="M161.71,263.3c4.52-.02,9.04-.03,13.56-.05,1.4,1.37,3.18,.76,4.78,.78,7.87,.09,15.74,.14,23.62,.08,2.5-.02,3.78,.8,3.58,3.46-.16,2.17-.17,4.34-.24,6.52-1.32,2.88-1.63,5.61,1.1,7.93,.04,2.43,.08,4.86,.12,7.3-29.17,.02-58.33,.04-87.5,.05-.38-.51-.76-1.01-1.17-1.57,2.09-1.27,5.21-.53,6.5-3.32,0,0,.45-.15,.45-.15,.95,0,1.83-.13,2.23-1.18,4.55-3.67,4.69-4.08,3.13-8.81-.04-2.16-.17-4.32-.11-6.48,.09-3.46,.22-3.63,3.73-3.68,7.15-.1,14.31-.04,21.46-.13,1.6-.02,3.35,.57,4.77-.74Zm7.82,3.85c-5.51,0-11.03,.05-16.54-.03-2.27-.03-3.4,.75-3.35,3.16,.08,4.01,.03,8.02-.03,12.02-.03,2.01,.68,3.12,2.88,3.11,11.19-.05,22.39-.08,33.58-.05,2.41,0,3.2-1.11,3.15-3.38-.09-3.84-.14-7.69,.01-11.52,.11-2.76-1.26-3.39-3.66-3.35-5.35,.08-10.69,.03-16.04,.03Z"
            fill="#fddf79"
          />
          <path
            d="M126.07,284.47c-1.29,2.79-4.42,2.05-6.5,3.32,.41,.55,.79,1.06,1.17,1.57-14.1-.01-28.19-.02-42.29-.03-.47-1.88,.83-2.9,1.97-3.99,.76-5.18-.1-10.35-.1-15.52-.59-.22-1.19-.44-1.78-.66-.55-.35-1.06-.79-1.65-1.03-1.78-.71-1.18-1.63-.31-2.62,1.26-1.44,2.95-1.32,4.61-1.32,10.14-.02,20.27-.04,30.41-.06,.03,1.66,.06,3.31,.08,4.97-1.79,.38-3.58,.78-5.37,1.14-2.49,.49-4.75,1.51-6.75,3.06-2.7,2.11-2.94,5.3-.65,7.79,1.27,1.38,2.84,2.41,4.62,2.88,5.29,1.4,10.55,3.04,16.16,1.48,2.06-.57,4.24-.67,6.37-.98Z"
            fill="#ebb740"
          />
          <path
            d="M207.01,274.08c.08-2.17,.08-4.35,.24-6.52,.19-2.66-1.08-3.47-3.58-3.46-7.87,.06-15.74,0-23.62-.08-1.61-.02-3.38,.6-4.78-.78,11.38-.02,22.81-.72,34.12,.13,12.37,.93,24.72,.33,37.06,.85,0,8.37,0,16.74,.01,25.1-12.74,0-25.49-.02-38.23-.03-.04-2.43-.08-4.86-.12-7.29,3.83,1.54,7.51,3.59,11.82,3.46,.53,1.18,1.41,1.81,2.74,1.75,3.96-.18,7.93,.41,11.89-.79,2.27-.69,4.4-1.31,6.15-3,3.15-3.03,3.21-3.22,.81-7.59-1.34-3.36-4.42-4.49-7.45-5.18-9.39-2.14-18.66-2.56-27.07,3.43Z"
            fill="#f7c942"
          />
          <path
            d="M234.17,261.83c.48-1.61,1.74-1.81,3.16-1.8,2.17,.02,4.34-.03,6.51-.02,1.26,0,2.32-.26,2.83-1.57,1.33-.3,2.02-1.28,2.58-2.41,1.17-.4,1.71-1.55,.97-2.24-2.89-2.72-5.28-6.22-9.63-6.92-.11-1.47-1.19-2.31-2.06-3.32-1.85-2.14-3.63-4.34-5.43-6.53-.57-.69-.81-1.54-.29-2.3,.43-.63,1.16-.44,1.81-.19,1.62,.62,3.28,.48,4.94,.17l-.09,.2c.35,.36,.69,.71,1.04,1.07l-.05-.07c-.09,1.19,.07,2.34,.86,3.27,4.02,4.73,8.3,9.04,15.13,9.11,.38,1.29,1.33,1.65,2.56,1.64,1.75-.01,3.49,.02,5.24,.04,.98,.17,2.34,.29,1.9,1.64-.68,2.09-.61,3.81,.81,5.59,1.07,1.34,.47,2.52-1.03,3.16-.75,.32-1.57,.65-2.37,.68-9.79,.34-19.55,1.88-29.37,.79Z"
            fill="#ebb740"
          />
          <path
            d="M96.56,258.94c3,2.16,6.42,.63,9.62,1.09,1.7,.25,3.81-.64,4.65,1.8-8.32,.15-16.64,.95-24.94-.57-2.43-.45-5-.21-7.5-.17-2.11,.03-3.05-.86-3-2.99,.07-3.01,.02-6.01,.02-9.02,1.83-.04,3.66-.03,5.48-.11,7.45-.32,15.86-6.45,17.83-12.99,.22-.33,.44-.66,.66-.99,1.5-.1,3-.15,4.49-.34,.79-.1,1.68-.79,2.29,.05,.7,.97,.1,1.91-.58,2.69-3.83,4.38-7.54,8.9-12.65,11.92-2.05,1.21-3.57,2.95-4.69,4.98-1.1,2,.7,1.6,1.72,1.77,1.04,3.64,3.97,2.92,6.61,2.86Z"
            fill="#ebb740"
          />
          <path
            d="M246.46,289.33c0-8.37,0-16.74-.01-25.11,3.95-.01,7.91-.04,11.86-.03,.82,0,1.67,.01,2.44,.23,1.09,.31,2.36,.61,2.61,1.95,.3,1.67-1.33,1.55-2.2,2.14-.27,.18-.49,.43-.73,.66-.67,.05-1.34,.11-1.81,.69-.35,4.08-1.14,8.13-.9,12.25,.06,1.13-.19,2.33,.82,3.21,.01,1.34,.02,2.67,.03,4.01-4.03,0-8.07,0-12.1-.01Z"
            fill="#ebb740"
          />
          <path
            d="M283.97,214.62c-3.67-.25-5.9,1.15-6.45,5.05-.23,1.59-1.18,3.08-1.84,4.6-1.41,3.25-2.01,6.48,.01,9.72,0,0,0-.07,0-.07-2.27-1.49-4.49-1.36-6.76,.08-1.35,.85-2.82,1.52-4.23,2.27,.03-.83-.1-1.69,.1-2.47,2.18-8.34,4.36-16.68,6.67-24.98,.76-2.75,1.32-5.48,1.15-8.33,1.45-1.01,1.7,.4,2,1.14,.93,2.32,1.62,4.75,2.57,7.06,1.19,2.91,2.81,5.41,6.54,5.17,.07,.25,.15,.5,.24,.75Z"
            fill="#ebb740"
          />
          <path
            d="M54.28,213.79c3.95,.54,6.12-1.59,7.4-4.98,.93-2.45,1.73-4.94,2.7-7.37,.29-.73,.71-2.07,1.94-.73-.31,6.01,2.47,11.37,3.56,17.09,1.19,6.22,3.93,12.07,4.33,18.47-3.33-1.03-5.86-4.46-9.92-3.28,.85-3.77,.89-3.78-1.16-8.44-.55-1.25-.67-2.53-.9-3.83-.74-4.23-1.92-5.29-6.34-5.92-.71-.1-1.23-.42-1.61-1Z"
            fill="#ebb740"
          />
          <path
            d="M111.68,269.11c-.03-1.66-.06-3.31-.08-4.97,14.88,.13,29.71-1.59,44.6-.98,1.84,.07,3.68,.09,5.52,.14-1.42,1.31-3.17,.72-4.77,.74-7.15,.09-14.31,.03-21.46,.13-3.51,.05-3.64,.22-3.73,3.68-.06,2.16,.07,4.32,.11,6.48-3.86-3.14-8.35-4.66-13.23-5.05-2.31-.18-4.63-.12-6.95-.17Z"
            fill="#f7c942"
          />
          <path
            d="M98.71,235.99c-1.97,6.53-10.38,12.67-17.83,12.99-1.83,.08-3.65,.08-5.48,.11-6.45-.66-10.85-3.84-12.6-10.28-.45-1.65-.73-3.26,.37-4.78,.45,4.85,3.5,7.78,7.58,9.7,8.24,3.88,15.81,2.4,22.79-3.21,1.79-1.44,2.97-3.57,5.17-4.54Z"
            fill="#f8dbb2"
          />
          <path
            d="M256.43,248.29c-6.83-.07-11.11-4.38-15.13-9.11-.79-.93-.95-2.08-.86-3.27,1.46,.59,2.21,1.98,3.23,3.03,8.08,8.36,21.42,10.2,30.79-.14,.14,.12,.28,.24,.42,.37-.67,4.22-2.37,7.51-7.19,8-3.66,1.3-7.51,.63-11.25,1.13Z"
            fill="#f8dbb2"
          />
          <path
            d="M256.43,248.29c3.74-.5,7.59,.17,11.25-1.13-.2,2.1-2.53,1.58-3.45,2.8-1.75-.02-3.5-.05-5.25-.04-1.23,0-2.18-.36-2.56-1.64Z"
            fill="#fddf79"
          />
          <path
            d="M53.1,208.81c.4,1.67,.79,3.34,1.19,5.02-2.31-1.22-2.73-2.89-1.19-5.02Z"
            fill="#f8dbb2"
          />
          <path
            d="M258.62,269.87c.47-.58,1.14-.64,1.81-.69,.58,.94,1.55,1.73,1.16,3.04-.99-.78-1.98-1.57-2.98-2.35Z"
            fill="#f8dbb2"
          />
          <path
            d="M275.7,233.99c1.03,1,1.35,1.99-.03,2.96,0,0-.08-.07-.08-.07,.04-.99,.08-1.98,.11-2.96,0,0,0,.07,0,.07Z"
            fill="#fddf79"
          />
          <path
            d="M78.44,270.15c.35,1.06-.36,1.56-1.07,2.07-.21-.98,.03-1.73,1.07-2.07Z"
            fill="#f8dbb2"
          />
          <path
            d="M78.54,269.16c.59,.22,1.19,.44,1.78,.66-.62,.24-1.19,.7-1.93,.4l.15-1.06Z"
            fill="#f8dbb2"
          />
          <path
            d="M275.67,236.96c.03,.25,.04,.51,.02,.76-.25,.11-.5,.14-.77,.11-.04-.5,.16-.83,.67-.94l.08,.07Z"
            fill="#fddf79"
          />
          <path
            d="M274.92,237.83c.27,.04,.52,0,.77-.11,.03,.65-.18,1.16-.82,1.44-.13-.12-.27-.24-.41-.36,.15-.32,.31-.65,.46-.97Z"
            fill="#f8dbb2"
          />
          <path
            d="M283.97,214.62c-.09-.25-.17-.5-.24-.75,.34-.01,.68-.03,1.01-.04,0,0-.03-.05-.03-.05-.25,.28-.5,.56-.74,.84Z"
            fill="#f8dbb2"
          />
          <path
            d="M295.72,131.35c-1.67-.08-2.17-1.42-2.71-2.62-3.5-7.7-9.59-12.9-17.06-16.15-6.33-2.75-13.28-3.23-20.15-1.96-12.29,2.27-24.06,6.54-36.13,9.66-6.12,1.58-12.23,3.21-18.35,4.76-.91,.23-1.99,.56-2.59-.69,.08-1.32,1.24-1.51,2.09-1.84,12.76-4.96,25.25-10.53,37.65-16.32,4.67-2.18,9.69-3.59,14.53-5.4,1-.37,1.9-.73,2.61,.41-1.77,.85-3.17,2.37-5.13,2.88-7.27,2.02-30.56,12.42-32.55,14.54,1.24,.67,2.27-.24,3.3-.55,6.52-1.95,13.05-3.92,19.49-6.11,3.91-1.33,8.19-1.4,11.81-3.63,2.68-.28,5.58,.93,8.01-1.15,2.36,.03,4.72,.06,7.08,.09,2.61,1.53,5.66,1.74,8.42,2.87,9.86,4.02,16.64,10.85,19.66,21.19Z"
            fill="#f7c942"
          />
          <path
            d="M267.64,107.29c-2.36-.03-4.72-.06-7.08-.09-1.28-2.29-2.06-4.55-1.93-5.57,.33-.18,.65-.37,.98-.55,.24,.21,.51,.35,.82,.42,.9,2.47,3.06,1.63,4.7,1.56,6.63-.29,12.86,1.05,18.71,4.14,1.51,.8,3.08,1.22,4.79,1.03,0,0,.07,.07,.07,.07,.35,3.76,2.73,5.76,6.05,6.95,.04,.31,.12,.61,.23,.9-.11,2.33,1.59,3.98,2.28,6.01,.45,1.33,1.24,2.76-.53,3.76-1.1-.69-1.4-1.69-1.91-2.54-5.13-8.56-12.45-14.22-22.17-16.68-1.74-.44-3.54-1.26-5,.61Z"
            fill="#fffefe"
          />
          <path
            d="M267.64,107.29c1.46-1.87,3.27-1.05,5-.61,9.72,2.46,17.04,8.12,22.17,16.68,.51,.85,.81,1.85,1.91,2.54,1.77-1,.98-2.43,.53-3.76-.69-2.03-2.39-3.67-2.28-6.01,.92,.06,1.85,.12,2.77,.18,.06,.25,.12,.51,.15,.77,.15,1.94,.57,3.7,2.77,4.31,.73,1.94,1.46,3.88,2.19,5.82,0,1.02,0,2.03,0,3.05-.53,.41-.94,.89-.96,1.59-.05,2.74-1.64,3.63-4.12,3.47-.28-.07-.56-.12-.85-.15-.17-1.35,.16-2.86-1.22-3.83-3.02-10.34-9.8-17.17-19.66-21.19-2.76-1.12-5.81-1.34-8.42-2.87Z"
            fill="#f8dbb2"
          />
          <path
            d="M297.79,135.33c2.48,.16,4.07-.73,4.12-3.47,.01-.7,.43-1.18,.96-1.59,1.45,2.99,1.99,6.19,2.03,9.47,.06,5.93,.24,11.87-.91,17.75-.02,.67-.04,1.34-.06,2-3.08,2.75-3.42,2.67-4.21-1.04,0-1.66,0-3.32,0-4.98,.56-6.17-.28-12.19-1.93-18.13Z"
            fill="#fddf79"
          />
          <path
            d="M188.12,132.41c.15,1.43-.48,3.03,.87,4.21-.3,.23-.61,.46-.91,.69-.66,0-1.31,.03-1.97,.02-5.38-.05-5.77-.45-6.02-5.89-.06-1.43,.42-3-.94-4.14-.01-1.63-.02-3.27-.03-4.9,1.82-1.24,.06-3.84,1.92-5.07q.02,7.71,7.86,8.17c.2,2.36-1.3,4.52-.78,6.91Z"
            fill="#fddf79"
          />
          <path
            d="M288.63,108.22c-1.71,.2-3.28-.23-4.79-1.03-5.86-3.09-12.08-4.43-18.71-4.14-1.65,.07-3.8,.91-4.7-1.56,3.24-1.42,6.67-1.38,10.11-1.28,1.9,1.15,4.03,1.42,6.19,1.57,3.15,.98,6.46,1.48,9.37,3.2,1.3,.76,2.75,1.33,2.54,3.24Z"
            fill="#f8dbb2"
          />
          <path
            d="M303.99,157.49c1.14-5.87,.96-11.81,.91-17.75-.03-3.28-.58-6.48-2.03-9.47,0-1.02,0-2.03,0-3.05,1.08,.15,1.63,.76,2.11,1.79,1.02,2.17,1.21,4.55,1.46,6.77,.73,6.58,1.13,13.21-.53,19.77-.28,1.12-.78,1.77-1.91,1.94Z"
            fill="#f7c942"
          />
          <path
            d="M299.72,158.45c.8,3.71,1.13,3.8,4.21,1.04,.59,4.66-1.64,8.43-3.96,12.13-.49,.78-1.8,.74-1.88-.29-.31-4.09-.81-8.22,.33-12.27,.08-.3,.85-.41,1.3-.61Z"
            fill="#f7c942"
          />
          <path
            d="M258.63,101.63c-.14,1.02,.65,3.28,1.93,5.57-2.43,2.09-5.33,.87-8.01,1.15-.93-1.3-2.48-2.3-2.06-4.26,1.96-.51,3.36-2.03,5.13-2.88,.63-.08,1.26-.15,1.89-.23,.38,.22,.75,.43,1.12,.64Z"
            fill="#f8dbb2"
          />
          <path
            d="M297.79,135.33c1.65,5.94,2.49,11.96,1.93,18.13-1.09-.21-1.9-.78-1.84-1.97,.24-5.02-.5-9.89-1.91-14.69-.2-.69,.44-1.19,.96-1.62,.29,.03,.57,.08,.85,.15Z"
            fill="#f7c942"
          />
          <path
            d="M294.74,115.23c-3.31-1.19-5.69-3.18-6.05-6.95,3.18-.44,4.42,2.03,5.99,4,.02,.98,.04,1.97,.05,2.95Z"
            fill="#f8dbb2"
          />
          <path
            d="M276.73,101.79c-2.16-.15-4.28-.41-6.19-1.57,2.75-1.28,3.81-1.01,6.19,1.57Z"
            fill="#f7c942"
          />
          <path
            d="M294.74,115.23c-.02-.98-.03-1.97-.05-2.95,1.77,.77,3.09,1.89,3.05,4.03-.93-.06-1.85-.12-2.77-.18-.11-.29-.18-.59-.23-.9Z"
            fill="#fddf79"
          />
          <path
            d="M300.67,121.4c-2.21-.61-2.63-2.38-2.77-4.31,2.27,.57,2.74,2.3,2.77,4.31Z"
            fill="#fddf79"
          />
          <path
            d="M258.63,101.63c-.37-.21-.75-.43-1.12-.64,.11-.6,.22-1.35,.88-1.44,1.07-.14,1.07,.81,1.23,1.53-.33,.18-.65,.37-.98,.55Z"
            fill="#f7c942"
          />
          <path
            d="M80.51,291.41c1.99,0,3.98,0,5.97,0,1.36,1.47,3.14,.89,4.75,.89,52.5,.03,105,.03,157.51,0,1.61,0,3.39,.58,4.76-.89,1.32,0,2.65-.01,3.97-.02,.65,2.66,3.6,2.57,5.16,4.31,2.04,2.27,3.83,4.45,2.77,7.51-1,2.9-2.79,5.34-6.24,5.83-3.62,.51-7.16,1.4-10.89,1.4-53.13-.07-106.26-.06-159.39,0-3.42,0-6.56-.54-9.7-1.93-6.78-3.02-7.65-8.92-1.8-13.5,1.3-1.02,3.04-1.56,3.13-3.59Zm24.63,4.36c-4.07-.55-7.84,1.08-11.72,1.77-.82,.15-1.51,.75-1.58,1.72-.07,.99,.58,1.58,1.39,1.86,1.41,.49,2.87,1.15,4.32,1.2,6.72,.2,13.33,1.46,20.14,1.24,14.9-.47,29.82-.15,44.73-.15,15.08,0,30.16-.02,45.24,.02,4.45,.01,8.88,.75,13.35,0,1.96-.33,3.85-1.56,5.88-.9,4.42,1.43,8.77,.1,13.15-.08,1.66-.07,3.35,.05,4.92-.74,.99-.5,2.51-.43,2.34-2.09-.17-1.63-1.42-1.99-2.84-2.28-8.26-1.71-16.66-1.92-25.02-1.95-34.01-.13-68.02-.05-102.03-.06-4.1,0-8.13,1.11-12.26,.45Z"
            fill="#bdcbd3"
          />
          <path
            d="M80.51,291.41c-.09,2.03-1.83,2.58-3.13,3.59-5.85,4.59-4.97,10.49,1.8,13.5,3.14,1.4,6.28,1.94,9.7,1.93,53.13-.06,106.26-.07,159.39,0,3.73,0,7.27-.88,10.89-1.4,3.45-.49,5.24-2.93,6.24-5.83,1.06-3.06-.73-5.24-2.77-7.51-1.56-1.73-4.51-1.65-5.16-4.31,1.51-.03,3.02-.1,4.52-.09,5.98,.04,10.77,4.9,10.67,10.8-.08,4.97-4.84,9.77-9.83,10.36-9.17,1.08-18.36,.98-27.55,.97-47.81,0-95.61-.01-143.42,.01-5.52,0-10.94-1.11-16.48-1.2-5.16-.08-9.46-6.14-9.05-11.43,.42-5.54,4.58-9.44,10.16-9.51,1.34-.02,2.68,.06,4.02,.1Z"
            fill="#9eafb3"
          />
          <path
            d="M253.49,291.42c-1.36,1.46-3.15,.89-4.76,.89-52.5,.03-105,.03-157.51,0-1.61,0-3.39,.57-4.75-.89-1.4-1.76-3.37-.93-5.11-1.1-3.93-.38-7.94,.7-11.82-.63,2.97-.11,5.93-.23,8.89-.35,14.1,.01,28.19,.02,42.29,.03,29.17-.02,58.33-.03,87.5-.05,12.74,0,25.49,.02,38.23,.03,4.03,0,8.07,0,12.1,.01,4.29,.11,8.58,.22,12.87,.34-4.23,1.26-8.56,.29-12.83,.63-1.74,.14-3.71-.67-5.11,1.1Z"
            fill="#9eafb3"
          />
          <path
            d="M165.79,82.86c.07-2.5,.15-5.01,.2-7.51,.04-2.47,1.79-2.41,3.51-2.42,1.75-.01,3.44,.02,3.45,2.48,.01,2.5,.1,5.01,.16,7.51-2.44-.02-4.88-.04-7.32-.06Z"
            fill="#ebb740"
          />
          <path
            d="M178.27,91.41c-5.44,.8-10.92,.66-16.39,.63-2.14,0-4.25-.11-6.37-1.96,9.27,0,18.08,0,26.9,0,1.01,0,2,.09,2.69,.99-2.28,.11-4.56,.23-6.83,.34Z"
            fill="#f8dbb2"
          />
          <path
            d="M8.92,159.48c1.44-.61,2.44-1.65,3.05-3.07,1.17-.02,2.35-.13,3.51-.03,2.84,.25,4.3,1.67,4.59,4.31,.3,2.75-1.24,5.52-3.64,6.52-2.3,.96-4.52,.22-6.12-2.02-1.24-1.72-1.53-3.66-1.39-5.72Z"
            fill="#e0e7ea"
          />
          <path
            d="M156.27,81.62c-.04-.26-.12-.51-.24-.75,1.03-6.53,2.76-8.72,7.83-9.9,.24,3.36,.58,6.72,.07,10.09-.36,.19-.72,.38-1.08,.57-2.19,0-4.39,0-6.58,0Z"
            fill="#fffefe"
          />
          <path
            d="M174.49,69.17c2.28,3.61,5.07,7.02,4.55,11.72-.37,.32-.75,.65-1.12,.97-2.49,.25-4.16-.31-3.88-3.38,.28-3.09,.31-6.2,.46-9.31Z"
            fill="#f8dbb2"
          />
          <path
            d="M163.85,70.97c-5.06,1.18-6.8,3.37-7.83,9.9-1.44,.07-2.03-.66-2.14-2.05-.32-3.89,1.59-6.64,4.64-8.62,1.62-1.05,3.34-2.11,5.38-2.3-.02,1.02-.04,2.05-.05,3.07Z"
            fill="#f8dbb2"
          />
          <path
            d="M177.92,81.85c.37-.32,.75-.64,1.12-.97,0,.3,.01,.6,.06,.89-.39,.03-.79,.05-1.18,.08Z"
            fill="#f7c942"
          />
          <path
            d="M162.85,81.63c.36-.19,.72-.38,1.08-.57-.12,.65-.5,.78-1.08,.57Z"
            fill="#f8dbb2"
          />
          <path
            d="M169.84,36.68c3.99,.89,5.97,3.64,4.96,6.88-.82,2.64-4.22,4.48-6.74,3.65-3.63-1.19-4.58-3.59-3.11-7.77,1.53,3.57,3.83,4.29,5.93,1.9,1.84-2.09-.36-3.18-1.04-4.66Z"
            fill="#9eafb3"
          />
          <path
            d="M169.84,36.68c.68,1.48,2.88,2.57,1.04,4.66-2.1,2.38-4.4,1.67-5.93-1.9,.71-2.56,2.82-2.62,4.89-2.76Z"
            fill="#e0e7ea"
          />
          <path
            d="M188.08,137.31c.3-.23,.61-.46,.91-.69,11.55,.55,23.18,1.15,34.17,4.93,7.1,2.44,13.82,3.43,21.36,2.16,8.11-1.37,16.31,.18,24.27,2.58,4.9,1.48,8.08,4.3,9.76,9.15,2.3,6.64,4.38,13.35,6.23,20.13,.57,2.09,1.3,4.13,1.96,6.2-.19,3.2-1.47,6.02-3.06,8.74-4.36-.68-4.43-.62-3.21,3.34,1.07,3.46,2.08,6.94,3.33,10.34,1.17,3.16,1.65,6.32,.93,9.63-.34,.01-.68,.03-1.01,.04-3.73,.24-5.35-2.26-6.54-5.17-.94-2.32-1.63-4.74-2.57-7.06-.3-.74-.56-2.15-2-1.14-.65,.6-.81,1.41-1.03,2.22-2.76,10.45-5.54,20.89-8.31,31.34-.17,.64-.52,1.33-.4,1.92,.29,1.37,1.13,.66,1.82,.3,1.41-.75,2.88-1.42,4.23-2.27,2.27-1.44,4.49-1.57,6.76-.08-.04,.99-.08,1.98-.11,2.96-.51,.11-.71,.44-.67,.94-.15,.32-.3,.64-.46,.97-9.36,10.34-22.71,8.5-30.79,.14-1.02-1.05-1.76-2.44-3.23-3.03,0,0,.05,.07,.05,.07-.11-.58-.43-.97-1.04-1.07,0,0,.09-.2,.09-.2,.18-1.45-.67-2.6-1.16-3.85,.78-.23,1.6-.36,2.32-.71,4.29-2.05,4.51-4.59,.73-8.06-2.3-.1-2.29-1.56-1.92-3.24l-.08,.08c1.5-.42,2.84-1.16,4.07-2.09,0,0-.06,.03-.06,.03,1.02,0,2.03,0,3.05,0,0,0-.06-.03-.06-.03,.5,.71,1.15,1.13,2.06,1.06l-.06-.06c-.06,.9,.27,1.59,1.06,2.05l-.03-.05c.13,1.13,.21,2.28,.39,3.4,.15,.91-.16,2.24,1.05,2.45,1.24,.22,2.02-.82,2.62-1.83,0,0-.01,.01-.01,.01,.34-.34,.68-.68,1.02-1.02h-.01c.53-.13,.87-.46,.99-1.01h0c1.12-.71,1.88-1.66,2.05-3.01,0,0-.01,.02-.01,.02,3.33-4.56,4.97-9.48,3.26-15.13-2-7.38-6.68-9.24-13.02-5.24-1.1,.7-1.93,1.88-3.37,2.02,.16-1.99,1.53-3.74,1.13-5.83,.52-.14,.89-.44,.97-1.01l-.04,.07c2.93-6.73,3.21-13.46-.01-20.19v.02c-.04-.87-.32-1.63-1-2.21-.71-2.59-1.79-4.98-3.66-6.96-1.08-1.68-1.36-4.38-4.45-3.55-2.39,1.33-4.14,3.39-5.94,5.35-6.84,7.44-10.47,15.88-8.24,26.2,.28,1.29,.78,2.79-.18,4.45-1-.65-1.67-1.11-2.37-1.53-8.57-5.13-16.3-1.41-17.44,8.48-.67,5.82,.44,11.31,3.7,16.27l.1-.08c-.03,.96,.04,2.3,.99,2.35,1.57,.09,1.13-1.51,1.36-2.49,.98-1.3,1.97-2.61,2.95-3.91,.79-.15,1.54-.38,1.99-1.13,2.66-.23,5.19,.28,7.62,1.36,.51,1.18,1.84,2.06,1.34,3.61-5.44,1.32-6.34,3.81-2.93,8.04,.18,.31,.37,.61,.55,.92-.16,.74-.33,1.48-.49,2.22-.12,.16-.14,.32-.05,.5-.77,.64-1.32,1.38-1.08,2.46l.04-.06c-.77-.06-.98,.42-1.04,1.05l.03-.05c-1.51,1.5-3.03,3.01-4.54,4.51-7.8,7.75-24.28,10.47-33.78-.98-.51-.62-.93-1.39-1.85-1.53,0,0,.02,.06,.02,.06,.16-1.01-.27-1.77-1.03-2.38-.39-2.6-1.4-5.08-1.26-7.81,.27-5.33,3.73-7.38,8.43-4.77,1.88,1.04,3.51,2.44,4.87,4.17,1.11,1.42,2.26,2.86,3.89,3.79,.41,.73,.84,1.59,1.73,1.62,1.23,.04,.96-1.06,1.06-1.82,.02-.16,0-.33,0-.5,0-11.2,0-22.4-.03-33.6,0-.81,.02-1.69-1.42-2.21-3.13,2.29-6.52,4.69-9.81,7.21-1.65,1.26-3.31,2.26-5.47,2.02,0,0,.02,.07,.02,.07-.12-.59-.55-.87-1.08-1.04,0,0,.06,.07,.06,.07-.33-.48-.67-.96-1-1.43-.09-2.17,1.03-3.63,2.53-5.1,3.41-3.34,7.11-6.42,9.92-10.33,.66-.72,2.37-1.18,.64-2.51-.52-6.32-.62-12.68-1.85-18.93-.15-3.32-.31-6.64-.46-9.96-.05-1.37-.09-2.74-.14-4.11,.11-4.02,.23-8.04,.34-12.06Z"
            fill="#d12438"
          />
          <path
            d="M179.12,122.39c.01,1.63,.02,3.27,.03,4.9-.09,2.02-.19,4.03-.28,6.05-1.25,1.08-.84,2.52-.85,3.87-.56,.02-1.13,.04-1.69,.06-.01-.67-.02-1.34-.04-2.02,.1-.09,.29-.23,.28-.25-.12-.18-.27-.35-.41-.52-1.15-2.78-2.79-4.95-6.17-4.97-3.06-.4-5.2,.77-6.33,3.68-.34,.36-.68,.72-1.02,1.09-.86,.02-1.72,.03-2.58,.05-.09-1.34-.18-2.68-.27-4.02,.06-1.65,.13-3.3,.2-4.95,3,.14,3.08-1.87,2.97-4.03,0,0,.49,.03,.49,.03l.48-.09h-.02c-.07,.89,.28,1.62,.95,2.19,3.61,3.07,7.43,2.27,10.95-2.3,1.1,.41,2.2,.82,3.3,1.22Z"
            fill="#f7c942"
          />
          <path
            d="M175.82,121.17c-3.52,4.57-7.35,5.38-10.95,2.3-.67-.57-1.02-1.31-.95-2.21,1.5-.01,3,.05,4.49-.06,3.06-.23,4.38-1.59,4.58-4.74,.07-1.16-.08-2.33-.13-3.49,3.61,1.79,3.44,4.93,2.96,8.19Z"
            fill="#889fa8"
          />
          <path
            d="M172.85,112.98c.05,1.16,.21,2.33,.13,3.49-.2,3.15-1.52,4.51-4.58,4.74-1.49,.11-3,.04-4.49,.06,0,0,.02,.01,.02,.01,.08-1.05,.16-2.11,.24-3.16,.92,.32,1.81,.76,2.76,.93,2.33,.43,3.81-.46,3.98-2.39,.2-2.19-.88-3.37-3.11-3.42-.65-.02-1.3,.01-1.95,.02,2.26-1.94,4.61-1.6,7.01-.28Z"
            fill="#bdcbd3"
          />
          <path
            d="M165.85,113.26c.65,0,1.3-.04,1.95-.02,2.23,.05,3.3,1.23,3.11,3.42-.17,1.93-1.65,2.82-3.98,2.39-.94-.18-1.84-.61-2.76-.93-.06-.99-.12-1.97-.19-2.96,0,0,.06,.05,.06,.05,.56-.21,.84-.63,.92-1.2,.3-.25,.6-.5,.9-.75Z"
            fill="#e0e7ea"
          />
          <path
            d="M163.98,115.16c.06,.99,.12,1.97,.19,2.96-.08,1.05-.16,2.11-.24,3.16,0,0-.48,.09-.48,.09,0,0-.49-.03-.49-.03,.16-2.09-.84-4.36,1.02-6.17Z"
            fill="#889fa8"
          />
          <path d="M164.95,114c-.07,.58-.35,1-.92,1.2,.05-.59,.39-.97,.92-1.2Z" fill="#bdcbd3" />
          <path
            d="M136.8,98.87c.09,2.87-1.71,5.01-4.31,5.13-2.03,.09-4.81-2.85-4.74-5.01,.07-2.19,2.8-4.85,4.97-4.85,2.34,0,4,1.92,4.08,4.74Z"
            fill="#e0e7ea"
          />
          <path
            d="M31.04,87c1.19,.13,2.27-.31,3.4-.58,3.03-.74,5.06,.46,5.66,3.15,.66,2.99-.81,5.88-3.25,6.38-2.28,.47-5.25-1.78-5.67-4.49-.23-1.46-.09-2.98-.11-4.48,0,0-.01,.01-.01,.01Z"
            fill="#e0e7ea"
          />
          <path
            d="M16.01,182.65c.33-.33,.67-.67,1-1,.95-.27,1.88-.62,2.84-.81,3.35-.66,5.51,.54,6.13,3.35,.66,3.01-.71,5.72-3.22,6.37-2.52,.65-5.88-1.27-6.57-3.96-.32-1.25-.13-2.62-.18-3.94Z"
            fill="#e0e7ea"
          />
          <path
            d="M308.86,181.59c1.39,.21,2.6-.44,3.89-.74,2.13-.49,3.64,1.04,4.61,2.42,1.18,1.67,1,3.82-.27,5.63-1.08,1.53-2.65,2-4.42,1.72-2.25-.36-3.58-1.74-3.75-4.03-.12-1.66-.04-3.34-.04-5.01,0,0-.01,.01-.01,.01Z"
            fill="#e0e7ea"
          />
          <path
            d="M316.91,156.44c2.5,.04,5.01-.2,6.81,2.22,1.61,2.16,1.69,3.71-.13,5.77-1.91,2.17-3.71,2.62-5.69,1.43-2.43-1.47-3.46-3.69-2.6-5.87,.48-1.21,1.77-2.06,1.62-3.56,0,0-.02,.02-.02,.02Z"
            fill="#e0e7ea"
          />
          <path
            d="M89.55,76.88c-.03,1.33,0,2.66-.09,3.99-.17,2.28-1.45,3.68-3.67,4.08-1.97,.35-3.72-.24-4.73-2.02-1.06-1.87-.91-3.69,.4-5.57,1.97-2.81,4.47-2.19,7.08-1.49,.34,.34,.68,.68,1.02,1.02Z"
            fill="#e0e7ea"
          />
          <path
            d="M249.3,84.96c-2.33-.14-4.05-2.35-3.84-4.93,.21-2.52,2.11-4.19,4.7-4.11,2.58,.08,4.57,2.11,4.33,4.44-.22,2.17-3.09,4.72-5.19,4.59Z"
            fill="#e0e7ea"
          />
          <path
            d="M221.2,92.15c-.04-2.77,.2-5.5,1.13-8.14,2.32,.03,4.65-.3,6.47,1.83,1.32,1.55,2.25,3.17,1.05,4.94-1.16,1.72-2.42,3.81-5.2,2.93-.79-.25-1.61-.36-2.42-.54-.34-.34-.69-.69-1.03-1.03Z"
            fill="#e0e7ea"
          />
          <path
            d="M14.97,110.41c.13-2.76,2.22-4.54,5.04-4.28,2.53,.24,4.16,2.16,4.03,4.77-.12,2.58-1.93,4.3-4.54,4.3-2.81,0-4.67-1.97-4.53-4.79Z"
            fill="#e0e7ea"
          />
          <path
            d="M315.46,115.2c-2.81,.02-4.68-1.94-4.56-4.76,.11-2.59,1.89-4.31,4.5-4.32,2.81-.01,4.69,1.94,4.57,4.76-.11,2.59-1.9,4.31-4.51,4.32Z"
            fill="#e0e7ea"
          />
          <path
            d="M17.01,135.66c.07,2.62-1.76,4.7-4.12,4.66-2.17-.03-4.86-2.7-4.92-4.87-.07-2.35,2-4.22,4.61-4.17,2.61,.05,4.36,1.78,4.43,4.38Z"
            fill="#e0e7ea"
          />
          <path
            d="M113.59,88.87c.1,2.18-1.69,4.03-4.08,4.22-2.6,.21-4.81-1.54-4.91-3.89-.1-2.18,1.7-4.03,4.08-4.22,2.6-.21,4.81,1.54,4.91,3.89Z"
            fill="#e0e7ea"
          />
          <path
            d="M302.91,86.98c.34,.33,.67,.67,1.01,1-.25,1.91,.37,3.94-1.13,5.69-1.8,2.09-3.79,3.04-5.55,1.96-1.83-1.12-3.62-2.49-3.35-5.06,.2-1.9,2.7-4.22,4.73-4.51,1.55-.22,2.93,.35,4.3,.93Z"
            fill="#e0e7ea"
          />
          <path
            d="M317.92,131.28c.97-.14,1.96-.25,2.92-.43,2.45-.47,4.58,.5,5.68,2.7,.96,1.91,.34,3.48-1.08,4.93-1.37,1.39-2.81,2.36-4.84,1.6-2.04-.76-3.79-3.42-3.52-5.46,.15-1.13,.56-2.23,.85-3.34h-.01Z"
            fill="#e0e7ea"
          />
          <path
            d="M150.87,137.29l-.22-.22s.08-.3,.08-.3c.12-1.19,.24-2.38,.36-3.57,2.49,0,4.97,0,7.46-.01,.51,1.33,.29,2.71,.27,4.08-2.65,0-5.3,.01-7.95,.02Z"
            fill="#fddf79"
          />
          <path
            d="M66.3,107.94c-1.4,1.56-3.24,1.97-5.23,1.95,1.2-2.11,2.9-2.89,5.23-1.95Z"
            fill="#f8dbb2"
          />
          <path
            d="M158.83,137.27c.02-1.37,.24-2.74-.27-4.08,.02-.6,.04-1.2,.07-1.8,.39-.36,.79-.72,1.18-1.08,.09,1.34,.18,2.68,.27,4.02,.01,7.03,.02,14.06,.03,21.08-.71,2.19,.67,4.75-1.18,6.74-.02-3.9-.04-7.8-.06-11.71-.01-4.39-.02-8.79-.04-13.18Z"
            fill="#e0e7ea"
          />
          <path
            d="M97.56,163.61c1.03-1.44,1.41-3.94,4.18-2.61,.18,.16,.36,.34,.54,.51,0,0,.25,.19,.25,.19,.32,.27,.63,.55,.95,.82,0,0,.05,.06,.05,.06,.01,1.39,.03,2.77,1.86,3.04,.11,.61,.22,1.22,.32,1.83-.51,2.71,1.27,4.8,2.14,7.07,1.52,3.99,1.56,8.45,4,12.12,0,.63,.02,1.26,.03,1.89-.17,1.46-.68,2.99,.75,4.16,0,1.79-.05,3.58-.02,5.37,.05,3.56,.06,3.56,3.87,2.37,3.09,1.05,2.9,3.8,3.25,6.27-.95,1.48-2.84,1.34-4.09,2.51-3.4,3.21-3.58,3.68-.96,7.69-.07,.95-.14,1.9-.21,2.85-.58,.1-1.16,.2-1.74,.29-1.7-.03-3.41-.05-5.11-.08-1.83-5.12-5.94-7.56-10.77-9.12-3.14-1.01-3.7-1.74-3.21-4.87,.12-.79,.6-1.52,.91-2.28,.67,.09,1.33,.18,2,.26,1.12,1.22,2.23,2.45,3.37,3.65,.59,.63,1.38,1.19,2.2,.72,1.57-.91,2.24-2.55,2.34-4.21,.1-1.65,.96-3.89-1.87-4.39-.01-.66-.03-1.33-.04-1.99,1.51-1.2,.89-2.62,.52-4.11-1.15-4.63-2.2-9.2-2.05-14.12,.06-1.97,.11-4.21,.05-6.29-.11-3.72-2.1-6.49-3.48-9.6Z"
            fill="#f7c942"
          />
          <path
            d="M94.54,203.68c-.31,.76-.79,1.49-.91,2.28-.49,3.13,.07,3.85,3.21,4.87,4.83,1.56,8.94,4,10.77,9.12-2.2,1.26-4.64,.92-7.02,1.05-.2-1.85-1.08-3.04-3.05-3.18h0c-.43-.88-1.27-.91-2.07-.98,0,0,.07,.04,.07,.04-1.05-1.31-2.07-1.36-3.05,.08-1.77,1.79-3.04,3.7-3.34,6.41-.32,2.88-1.29,3.09-3.48,1.23-.87-.74-1.82-1.46-2.19-2.64-.05-.65-.11-1.3-.16-1.95,2.75-.46,3.87-2.23,2.76-4.64-1.65-3.59-2.27-7.64-4.72-10.87,3.64-3.75,6.98-3.96,13.21-.8Z"
            fill="#ebb740"
          />
          <path
            d="M97.56,163.61c1.38,3.11,3.37,5.88,3.48,9.6,.06,2.08,.01,4.31-.05,6.29-.15,4.92,.9,9.49,2.05,14.12,.37,1.49,.99,2.9-.52,4.11-2.44-3.41-2.34-7.52-3-11.39-.55-3.27-.75-6.6-1.09-9.9-.08-.74-.4-1.35-1.15-1.35-.42,0-.98,.37-1.22,.74-.54,.83-1.26,1.76-1.3,2.67-.13,3.43-1.36,6.71-.39,10.31,1.17,4.36,2.5,8.63,4.14,12.81,.37,.94,.97,1.88,2.17,1.73,1.15-.14,1.6-1.08,1.75-2.13,.07-.5,.08-1,.11-1.5,2.83,.5,1.98,2.73,1.87,4.39-.1,1.66-.77,3.31-2.34,4.21-.82,.48-1.61-.09-2.2-.72-1.14-1.2-2.25-2.43-3.37-3.65-.54-1.93-.29-4.29-2.85-5.09-.76-2.67-2.54-5.07-2.19-8.05-.23-5.79-.05-11.56,.99-17.27,0,0-.02,.05-.02,.05,.86-.45,.92-1.28,1.02-2.09,0,0-.05,.09-.05,.09,.8-.44,.94-1.22,1.03-2.01,.4-2.31,1.41-4.31,3.1-5.95Z"
            fill="#ebb740"
          />
          <path
            d="M116.46,200.41c-3.81,1.18-3.82,1.18-3.87-2.37-.02-1.79,.01-3.58,.02-5.36,1.31-1.67,1.64-3.16-.75-4.16,0-.63-.02-1.26-.03-1.89,1.34-1.79,.78-3.73,.42-5.65-.88-4.71-3.38-8.85-4.71-13.4l.12-.12c6.41,5.56,9.13,12.62,8.57,21.01-.19,2.77-1.12,5.5-.53,8.32-.74-.44-.74-.01-.63,.54,.19-.21,.37-.43,.56-.64,1.77-.19,2.85-1.65,4.34-2.37,6.47-3.11,12.63-.81,14.86,5.98,2.01,6.09,1.57,12.1-2.02,17.65,0-4.01,.08-8.02-.03-12.02-.1-3.71-3.14-8.55-6.09-8.96-3.82-.54-7.66-.2-10.21,3.46Z"
            fill="#f8dbb2"
          />
          <path
            d="M116.46,200.41c2.55-3.66,6.39-4,10.21-3.46,2.95,.42,5.99,5.25,6.09,8.96,.11,4,.03,8.01,.03,12.02,0,0,.04-.1,.04-.1-.95,.42-1.05,1.24-1,2.13,0,0,.12,.02,.12,.02-.79-.03-1.59-.06-2.38-.1-.99-1.32-1.97-2.65-2.96-3.97,.01-.34,.02-.68,.03-1.02,2.72-.58,2.53-2.37,1.41-4.09-1.92-2.94-4.59-4.71-8.34-4.13-.36-2.47-.16-5.22-3.25-6.27Z"
            fill="#fddf79"
          />
          <path
            d="M160.91,201.67c-1.43,3.04-2.46,3.67-5.67,3-2.96-.62-5.72-1.81-8-3.58-.98,.25-1.37,.75-1.37,1.48-.03,8.05-.05,16.09-.06,24.14,0,.87,.26,1.64,.99,2.19-.61,1.21-1.37,2.26-2.71,2.77-1.23-3.06-1.65-29.31-.55-38.67,4.11,2.24,7.49,5.15,11,7.8,2.07,1.56,4,2.38,6.37,.87Z"
            fill="#f8dbb2"
          />
          <path
            d="M89.95,256.08c-1.02-.17-2.82,.23-1.72-1.77,1.11-2.03,2.63-3.77,4.69-4.98,5.12-3.01,8.82-7.54,12.65-11.92,.69-.79,1.29-1.72,.58-2.69-.61-.84-1.5-.15-2.29-.05-1.49,.19-2.99,.23-4.49,.34-.9-1.75,.95-2.71,1.18-4.13,.64-.35,1.29-.7,1.93-1.06,2.71,.04,5.43,.31,8.13-.22,.68-.04,1.36-.09,2.03-.13,.49,.16,.78-.12,1.05-.46,1.38,0,2.75-.01,4.13-.02,.59,.56,.82,1.25,.73,2.05-1.67,.95-3.51,.83-5.34,.98-2.65,.22-3.45,1.9-1.8,4.03,1.52,1.96,3.35,3.67,5.44,5.11,1.73,1.19,3.78,2.3,3.82,4.88-3.29-.98-5.59-3.41-8.06-5.57-3.7-3.25-4.14-3.27-6.98,.42-2.23,2.91-4.89,5.33-7.75,7.64-2.16,1.74-4.99,2.77-6.35,5.45-1.18,.21-1.43,1.12-1.59,2.1Z"
            fill="#c68f43"
          />
          <path
            d="M158.86,150.45c.02,3.9,.04,7.8,.06,11.71,0,1.76,0,3.52,0,5.27-.07,1.31-.14,2.62-.22,3.94-.23-.6-.62-1.19-.67-1.81q-.55-6.06-6.39-6.12c-.33,0-.66-.02-1-.02,.18-4.68,.35-9.35,.53-14.03,2.63-.12,5.21,.17,7.7,1.07Z"
            fill="#fddf79"
          />
          <path
            d="M120.67,246.03c-.05-2.58-2.1-3.69-3.82-4.88-2.09-1.44-3.92-3.15-5.44-5.11-1.65-2.13-.85-3.81,1.8-4.03,1.83-.15,3.67-.03,5.34-.98,.11,.17,.13,.34,.06,.53,.08,.93-.01,1.94,1.1,2.38,0,0-.03-.06-.03-.06,.51,2.35,.64,5.01,4.05,5.04,0,0-.01,0-.01,0-.09,.77,.25,1.11,1.02,1.02,0,0,0,0,0,0-.8,2.05,1.35,2.69,1.94,4.08,.04,1.6,.08,3.21,.11,4.82-1.07-.16-1.95-1.04-3.13-.81l.02,.02c-.08-2.08-1.48-2.18-3.04-2.03l.02,.02Z"
            fill="#f7c942"
          />
          <path
            d="M126.68,244.01c-.59-1.38-2.74-2.03-1.94-4.08,.94-.1,1.52,.58,2.19,1.04,12.41,8.55,24.55,6.75,34-5.05,1.74,1.57,.18,2.92-.58,3.89-5.69,7.32-12.59,10.4-22.41,8.97-4.35-.63-7.66-2.85-11.26-4.77Z"
            fill="#f8dbb2"
          />
          <path
            d="M150.64,163.42c.33,0,.66,.02,1,.02q5.86,.06,6.39,6.12c.06,.62,.44,1.21,.68,1.81q-1.42,5.26-6.59,5.23c-.98,0-1.95-.07-2.93-.11,1.03-4.3-.1-8.83,1.45-13.07Z"
            fill="#ebb740"
          />
          <path
            d="M158.86,150.45c-2.49-.9-5.07-1.18-7.7-1.07-.1-4.03-.19-8.06-.29-12.09,2.65,0,5.3-.01,7.95-.02,.01,4.39,.02,8.78,.04,13.18Z"
            fill="#f8dbb2"
          />
          <path
            d="M149.18,176.49c.98,.04,1.95,.1,2.93,.11q5.17,.04,6.59-5.23c.07-1.31,.14-2.63,.21-3.94,1.36,1.12,.97,2.68,1.02,4.11,.12,3.42-.9,7.16,2.88,9.5,.23,.14,.05,.93,.06,1.43-4.74,.27-9.47,.35-14.2-.05,.17-1.98,.34-3.96,.51-5.94Z"
            fill="#c68f43"
          />
          <path
            d="M148.67,182.43c4.73,.4,9.47,.31,14.21,.05,9.11,.18,18.21,.3,27.31-.1,1.73,1.33,.02,1.79-.64,2.51-7.67-.7-15.35-.14-23.03-.27-5.85-.1-11.69-.02-17.54-.01-.71-.64-1.93-1.21-.31-2.18Z"
            fill="#e0e7ea"
          />
          <path
            d="M117.81,228.98c-1.38,0-2.75,.01-4.13,.02-.35,.15-.7,.31-1.05,.46-.68,.04-1.36,.09-2.03,.13-1.91-4.53-4.57-8.18-10.02-8.59,2.37-.13,4.81,.21,7.02-1.05,1.71,.03,3.41,.05,5.11,.08-.1,1.31,.68,2.19,1.56,2.96,1.66,1.47,2.73,3.32,3.57,5.32,.08,.23,.07,.45-.03,.67Z"
            fill="#f8dbb2"
          />
          <path
            d="M100.59,221c5.45,.41,8.11,4.06,10.02,8.59-2.7,.53-5.41,.26-8.13,.22-.05-4.04-3.45-5.08-6.1-6.8,.19-.26,.33-.61,.58-.77q2.77-1.78,.56-4.42c1.98,.14,2.86,1.33,3.05,3.18Z"
            fill="#fddf79"
          />
          <path
            d="M74.21,236.27c-.39-6.4-3.14-12.26-4.33-18.47-1.09-5.72-3.86-11.08-3.56-17.09,2.88,6.63,3.86,13.8,5.96,20.66,1.41,4.64,2.55,9.37,3.64,14.09,.42,1.81-.74,1.36-1.71,.81Z"
            fill="#f8dbb2"
          />
          <path
            d="M77.66,208.84c-.57-2.51-.18-4.94,.82-7.25,2.17-5,6.53-6.48,11.37-3.84,.99,.54,1.81,1.39,2.71,2.09-2.21,1.28-4.31-.46-6.56-.22-3.85,.41-4.97,1.05-6.48,5.24-.03,.32-.08,.63-.17,.93-1.26,.63-.7,2.27-1.7,3.05Z"
            fill="#f8dbb2"
          />
          <path
            d="M79.52,204.86c1.5-4.19,2.63-4.83,6.48-5.24,2.25-.24,4.35,1.5,6.56,.22,.38-.33,.75-.66,1.13-.99,2.55,.8,2.31,3.16,2.85,5.09-.67-.09-1.33-.17-2-.26-6.23-3.15-9.57-2.95-13.21,.8-.6,.13-1.2,.25-1.8,.37Z"
            fill="#fddf79"
          />
          <path
            d="M96.38,223.02c2.64,1.72,6.04,2.76,6.1,6.8-.64,.35-1.29,.7-1.93,1.06-5.87-1.35-6.89-3.27-4.17-7.85Z"
            fill="#ebb740"
          />
          <path
            d="M117.85,228.31c-.84-2.01-1.91-3.86-3.57-5.32-.88-.78-1.66-1.65-1.56-2.96,.58-.1,1.16-.2,1.74-.29,.41,.03,.82,.05,1.24,.08,2.43-.06,4.14,1.05,4.74,3.38,.6,2.33-.27,4.15-2.59,5.12Z"
            fill="#e0e7ea"
          />
          <path
            d="M92.48,173.54c-1.04,5.72-1.21,11.48-.99,17.27-2.03-5.89-2.09-11.67,.99-17.27Z"
            fill="#fddf79"
          />
          <path
            d="M77.66,208.84c.99-.78,.43-2.42,1.7-3.05-.63,4.56,1.3,8.72,2.04,13.06h.01c-2.77-2.78-3.44-6.33-3.75-10.01Z"
            fill="#fddf79"
          />
          <path
            d="M124.68,214.84c-2.67-.24-5.22,.28-7.68,1.31,0,0-.35-.3-.35-.3,2.34-3.01,5.1-2.74,8.04-1.02h0Z"
            fill="#f8dbb2"
          />
          <path
            d="M123.73,238.93c-3.4-.03-3.54-2.68-4.05-5.04,1.99,1.16,3.29,2.88,4.05,5.04Z"
            fill="#f8dbb2"
          />
          <path
            d="M129.57,219.89c.79,.03,1.59,.06,2.38,.1,.02,.96-.05,2.27-1.01,2.35-1.63,.13-1.06-1.52-1.37-2.45Z"
            fill="#f8dbb2"
          />
          <path
            d="M105.69,167.44c-.11-.61-.22-1.22-.32-1.83,.04-.35,.08-.7,.13-1.04,1.25,.57,1.99,1.51,2.15,2.89,0,0-.12,.12-.12,.12-.61-.05-1.23-.09-1.84-.13Z"
            fill="#f8dbb2"
          />
          <path
            d="M105.5,164.57c-.04,.35-.08,.7-.13,1.04-1.83-.27-1.85-1.65-1.86-3.04,.91,.42,1.65,1.01,1.99,1.99Z"
            fill="#fddf79"
          />
          <path
            d="M115.7,219.81c-.41-.03-.82-.05-1.24-.08,.07-.95,.14-1.9,.21-2.85,.66-.35,1.32-.69,1.98-1.04,0,0,.35,.3,.35,.3-.47,1.21-1.84,2.1-1.31,3.67Z"
            fill="#f8dbb2"
          />
          <path
            d="M83.29,220c.05,.65,.11,1.3,.16,1.95-1.09-.76-1.98-1.66-2.04-3.11,0,0-.01,0-.01,0,.63,.38,1.26,.77,1.88,1.15Z"
            fill="#fddf79"
          />
          <path
            d="M92.46,216.95c.98-1.44,2-1.38,3.05-.08-1.02,.03-2.04,.05-3.05,.08Z"
            fill="#fddf79"
          />
          <path
            d="M126.64,214.9c-.01,.34-.02,.68-.03,1.02-.78-.12-1.5-.34-1.92-1.09,0,0,0-.01,0-.01,.65,.03,1.3,.05,1.95,.08Z"
            fill="#f8dbb2"
          />
          <path
            d="M95.45,216.84c.81,.08,1.64,.1,2.07,.98-.81-.08-1.56-.28-2.07-.98Z"
            fill="#fddf79"
          />
          <path
            d="M131.82,219.97c-.05-.89,.06-1.71,1-2.13-.12,.81,.14,1.8-1,2.13Z"
            fill="#f8dbb2"
          />
          <path
            d="M94.46,169.56c-.1,.8-.23,1.58-1.03,2.01,.06-.81,.25-1.57,1.03-2.01Z"
            fill="#fddf79"
          />
          <path
            d="M93.48,171.49c-.1,.82-.17,1.65-1.02,2.09,.07-.83,.22-1.62,1.02-2.09Z"
            fill="#fddf79"
          />
          <path
            d="M119.71,233.95c-1.12-.45-1.03-1.45-1.1-2.38,.75,.62,1.29,1.33,1.1,2.38Z"
            fill="#f8dbb2"
          />
          <path
            d="M161.03,196.72c.27,.41,.54,.81,.81,1.22-.27-.41-.54-.81-.81-1.22Z"
            fill="#f8dbb2"
          />
          <path
            d="M124.74,239.94c-.77,.09-1.11-.25-1.02-1.02,.71-.03,1.04,.31,1.02,1.02Z"
            fill="#f8dbb2"
          />
          <path
            d="M103.46,162.51c-.32-.27-.63-.55-.95-.82,.32,.27,.63,.55,.95,.82Z"
            fill="#fddf79"
          />
          <path
            d="M102.27,161.51c-.17-.18-.35-.35-.54-.51,.31,.02,.49,.19,.54,.51Z"
            fill="#fddf79"
          />
          <path
            d="M161.87,200.27c-.1,.65-.38,1.19-1.01,1.48,.34-.49,.68-.98,1.01-1.48Z"
            fill="#f8dbb2"
          />
          <path
            d="M179.09,202.65c2.16,.24,3.82-.76,5.47-2.02,3.3-2.52,6.68-4.92,9.81-7.21,1.44,.51,1.42,1.4,1.42,2.21,.02,11.2,.02,22.4,.03,33.6,0,.17,.01,.34,0,.5-.1,.76,.17,1.86-1.06,1.82-.89-.03-1.32-.89-1.73-1.62,.02-9.46,.04-18.91,.03-28.37,0-.42-.36-.84-.7-1.57-2.04,1.26-3.94,2.45-5.86,3.6-1.77,1.06-3.69,1.43-5.74,1.13-1.19-.18-1.67-.93-1.66-2.07Z"
            fill="#f8dbb2"
          />
          <path
            d="M165.96,203.71c3.58-2.04,6.84-1.14,9.46,1.57,2.27,2.35,3.43,5.32,1.98,8.68-1.42,3.31-3.88,5.47-7.51,5.73-3.48,.26-6.06-1.62-7.76-4.52-1.76-3-1.72-6,.82-8.68,.08,1.16-.08,2.39,.28,3.45,.79,2.34,3.5,3.45,6.22,2.77,2.33-.58,3.12-2.43,3.32-4.46,.22-2.21-1.8-4.16-4.33-4.49-.82-.11-1.66-.05-2.49-.07Z"
            fill="#9eafb3"
          />
          <path
            d="M89.95,256.08c.16-.98,.4-1.9,1.59-2.1,.85,1.43,2.28,1.15,3.56,1.15,10.45-.02,20.91-.07,31.36-.1,1.53,0,3-.06,4.05-1.4,1.03,.39,1.42,1.24,1.65,2.22-.59,2.25-1.99,3.36-4.37,3.2-3.97-.26-7.95-.16-11.94-.52-6.38-.57-12.89-1.27-19.28,.41-2.64,.06-5.57,.78-6.61-2.86Z"
            fill="#f8dbb2"
          />
          <path
            d="M249.25,256.03c-.56,1.13-1.25,2.11-2.58,2.41-8-.29-15.98-.73-23.99,.42-3.94,.57-8.02,.12-12.03,.18-2.25,.03-3.3-1.29-3.88-3.22,.24-.89,.5-1.76,1.52-2.08,.74,1.59,2.22,1.24,3.49,1.25,10.68,.07,21.37,.1,32.05,.12,1.29,0,2.73,.27,3.58-1.16,1.2,.17,1.35,1.27,1.83,2.07Z"
            fill="#f8dbb2"
          />
          <path
            d="M220.39,230.99c.16-.74,.33-1.48,.49-2.23,2.5,.16,5,.32,7.51,.48,2.61,1.22,5.35,.42,8.04,.55,.66,.35,1.32,.7,1.98,1.05,.49,1.25,1.34,2.4,1.16,3.85-1.66,.3-3.32,.44-4.94-.18-.65-.25-1.38-.44-1.81,.19-.52,.76-.28,1.61,.29,2.3,1.8,2.19,3.58,4.38,5.43,6.53,.87,1.01,1.96,1.85,2.06,3.32,0,0-.28,.33-.28,.33-3.46-1.29-5.41-4.3-7.68-6.89-2.52-2.88-2.73-3.03-5.47-.56-2.71,2.43-5.39,4.89-8.79,6.35-.13-.16-.25-.32-.37-.49,.08-.53,.16-1.07,.25-1.6,1.87-1.36,3.82-2.63,5.59-4.11,1.4-1.17,2.75-2.47,3.81-3.93,1.54-2.12,.7-3.78-1.94-3.99-1.83-.14-3.66-.03-5.33-.99Z"
            fill="#c68f43"
          />
          <path
            d="M178.11,236.89c.92,.14,1.34,.91,1.85,1.53,9.49,11.45,25.98,8.74,33.78,.98,1.51-1.5,3.03-3.01,4.54-4.51,.85,2.27-1.1,3.46-1.97,5.06-2.6,1.51-4.34,4.04-6.94,5.63-6.88,4.21-14.22,4.9-21.45,2.09-4.66-1.82-9.02-4.96-9.82-10.79Z"
            fill="#f8dbb2"
          />
          <path
            d="M184.31,254.95c-.39,1.85-1.7,2.2-3.36,2.2-7.66-.03-15.31-.03-22.97,0-1.68,0-2.95-.4-3.35-2.23,.36-.36,.73-.72,1.09-1.09,9.17,.37,18.34,.35,27.51,.01l1.08,1.11Z"
            fill="#f8dbb2"
          />
          <path
            d="M216.31,239.95c.87-1.61,2.81-2.79,1.97-5.06,0,0-.03,.05-.03,.05,.75,.04,1-.4,1.04-1.05,0,0-.04,.06-.04,.06,1.13-.48,1.03-1.5,1.08-2.46-.08-.18-.07-.34,.05-.5,1.66,.96,3.5,.85,5.33,.99,2.64,.2,3.48,1.86,1.94,3.99-1.06,1.46-2.42,2.76-3.81,3.93-1.77,1.48-3.72,2.75-5.59,4.11-.64-1.35-1.29-2.71-1.93-4.06Z"
            fill="#ebb740"
          />
          <path
            d="M165.96,203.71c.83,.02,1.67-.04,2.49,.07,2.53,.33,4.55,2.28,4.33,4.49-.2,2.03-1,3.88-3.32,4.46-2.72,.67-5.42-.43-6.22-2.77-.36-1.06-.21-2.3-.28-3.45,.84-1.11,1.61-2.28,3-2.79Z"
            fill="#e0e7ea"
          />
          <path
            d="M164.85,244.9c0-1.52,1.16-2.33,2.05-3.3,1.71-1.85,3.43-1.91,5.11,0,1.18,1.34,3.02,2.23,3.07,4.36l-.09,.1c-.86-.11-1.65-.44-2.2-1.09-2.01-2.4-4.08-2.67-6.4-.41-.32,.32-.92,.35-1.39,.52l-.15-.17Z"
            fill="#c68f43"
          />
          <path
            d="M132.15,255.85c-.22-.98-.62-1.83-1.64-2.22-1.45-1-3.01-1.87-3.84-3.54l.3-.27c2.17,.45,4.05,1.61,5.7,2.94,1.12,.9,2.28,2.5-.51,3.08Z"
            fill="#c68f43"
          />
          <path
            d="M155.72,253.82c-.36,.36-.72,.73-1.09,1.09-.94-.07-1.8-.57-1.2-1.47,1.27-1.91,2.81-3.66,5.5-3.38,0,0-.02-.03-.02-.03-1.06,1.26-2.13,2.53-3.19,3.79Z"
            fill="#c68f43"
          />
          <path
            d="M184.31,254.95c-.36-.37-.72-.74-1.08-1.11-1.06-1.27-2.11-2.54-3.17-3.81l-.02,.03c2.49-.32,3.92,1.34,5.25,2.97,.88,1.08,.28,1.75-.99,1.91Z"
            fill="#c68f43"
          />
          <path
            d="M158.93,250.06c.78-3.09,2.81-4.75,5.92-5.16,0,0,.14,.17,.14,.17-1.61,2.17-3.27,4.28-6.09,4.97l.02,.03Z"
            fill="#c68f43"
          />
          <path
            d="M208.29,253.75c-1.01,.32-1.28,1.19-1.52,2.08-2.21-.35-1.63-1.63-.82-2.78,.73-1.03,1.93-1.19,3.13-1.14,0,0,.18,.17,.18,.17-.32,.56-.64,1.12-.97,1.67Z"
            fill="#c68f43"
          />
          <path
            d="M175.08,245.95c2.26,.64,4.23,1.61,4.96,4.1,0,0,.02-.03,.02-.03-2.38-.44-3.81-2.11-5.07-3.98l.09-.1Z"
            fill="#c68f43"
          />
          <path
            d="M215.02,247.69c.32-1.67,1.67-1.84,2.98-2.07,.11,.16,.24,.33,.37,.48-.65,1.2-1.65,1.9-3.03,2-.11-.13-.22-.27-.32-.41Z"
            fill="#c68f43"
          />
          <path
            d="M212.04,249.77c.29-1.7,1.65-1.87,2.98-2.08,.1,.14,.21,.28,.32,.41-.64,1.24-1.64,1.91-3.04,1.99l-.26-.33Z"
            fill="#c68f43"
          />
          <path
            d="M209.08,251.9c.23-1.76,1.57-1.98,2.96-2.13,0,0,.26,.32,.26,.32-.62,1.27-1.64,1.91-3.04,1.98l-.18-.17Z"
            fill="#c68f43"
          />
          <path
            d="M123.67,248.02c1.17-.24,2.06,.64,3.13,.81,.05,.33,.11,.67,.17,1,0,0-.3,.27-.3,.27-1.4-.1-2.47-.7-3-2.07Z"
            fill="#c68f43"
          />
          <path
            d="M177.09,234.56c.76,.61,1.19,1.37,1.03,2.38-1.09-.47-1.06-1.43-1.03-2.38Z"
            fill="#f8dbb2"
          />
          <path d="M177.09,200.32c.33,.48,.67,.96,1,1.43-.62-.28-.9-.79-1-1.43Z" fill="#f8dbb2" />
          <path
            d="M178.03,201.69c.53,.17,.96,.45,1.08,1.04-.36-.35-.72-.69-1.08-1.04Z"
            fill="#f8dbb2"
          />
          <path
            d="M169.54,267.15c5.35,0,10.69,.05,16.04-.03,2.4-.04,3.77,.58,3.66,3.35-.15,3.84-.1,7.68-.01,11.52,.05,2.27-.73,3.38-3.15,3.38-11.19-.03-22.39,0-33.58,.05-2.2,.01-2.9-1.1-2.88-3.11,.06-4.01,.1-8.02,.03-12.02-.05-2.41,1.08-3.19,3.35-3.16,5.51,.08,11.03,.03,16.54,.02Zm-14.95,4.23c1.93,4.01,4.69,5.05,8.41,4.83,4.49-.26,9.02-.24,13.52,0,3.8,.2,6.24-1.21,7.78-4.83h-29.71Z"
            fill="#889fa8"
          />
          <path
            d="M111.68,269.11c2.32,.05,4.64-.01,6.95,.17,4.89,.39,9.38,1.91,13.23,5.05,1.57,4.73,1.42,5.14-3.13,8.81-.89,.11-1.71,.35-2.23,1.18,0,0-.45,.15-.45,.15-2.12,.31-4.31,.41-6.37,.98-5.61,1.55-10.87-.09-16.16-1.48-1.78-.47-3.35-1.49-4.62-2.88-2.29-2.49-2.05-5.69,.65-7.79,1.99-1.55,4.25-2.57,6.75-3.06,1.79-.36,3.58-.76,5.37-1.14Zm6.58,3.04c-2.53-.03-4.72-.18-6.7,1.02-.87,.53-1.79,1.06-1.62,2.26,.13,.91,.88,1.36,1.67,1.68,3.74,1.52,7.5,1.52,11.19-.08,2.02-.88,2.07-2.41,.36-3.83-1.59-1.32-3.47-.96-4.91-1.06Z"
            fill="#889fa8"
          />
          <path
            d="M207.01,274.08c8.4-5.99,17.68-5.58,27.07-3.43,3.02,.69,6.11,1.82,7.45,5.19,.31,3.76-1.74,5.83-4.97,7.18-2.94,1.23-5.88,2.22-9.15,2.15-2.49-.06-4.98,.19-7.47,.31-4.31,.13-7.99-1.91-11.82-3.46-2.74-2.32-2.42-5.05-1.11-7.93Zm10.45-1.46c-2.04-.54-3.37,.68-3.73,2.28-.42,1.85,1.54,2.24,2.84,2.8,.54,.23,1.25,.06,1.89,.08,2.24,.39,4.49,.41,6.73-.03,1.23,.55,2.25-.09,3.22-.65,2.05-1.2,2.14-2.2,.45-3.77-.76-.71-1.62-1.1-2.67-.68-.96-.09-1.92-.17-2.88-.26-1.34-1.47-2.66-1.51-3.96,.04-.63,.07-1.26,.13-1.89,.2Z"
            fill="#889fa8"
          />
          <path
            d="M126.51,284.32c.51-.83,1.33-1.07,2.23-1.18-.39,1.05-1.27,1.18-2.23,1.18Z"
            fill="#ebb740"
          />
          <path
            d="M219.94,285.47c2.49-.11,4.99-.36,7.47-.31,3.26,.07,6.2-.92,9.15-2.15,3.23-1.35,5.28-3.42,4.97-7.18,2.4,4.37,2.34,4.56-.81,7.59-1.76,1.69-3.88,2.31-6.15,3-3.96,1.2-7.93,.61-11.89,.79-1.32,.06-2.21-.57-2.74-1.75Z"
            fill="#c68f43"
          />
          <path
            d="M249.25,256.03c-.49-.8-.63-1.9-1.83-2.07-1.66-3-5.46-3.76-7.11-6.76,0,0,.28-.33,.28-.33,4.36,.7,6.75,4.19,9.64,6.92,.74,.7,.2,1.85-.97,2.24Z"
            fill="#c68f43"
          />
          <path
            d="M239.46,234.91c.61,.1,.92,.49,1.04,1.07-.35-.36-.69-.71-1.04-1.07Z"
            fill="#f8dbb2"
          />
          <path
            d="M264.71,236.28c-.69,.36-1.54,1.07-1.82-.3-.12-.59,.23-1.28,.4-1.92,2.77-10.45,5.55-20.89,8.31-31.34,.21-.81,.38-1.62,1.03-2.22,.17,2.85-.38,5.58-1.15,8.33-2.31,8.3-4.49,16.64-6.67,24.98-.2,.78-.08,1.65-.1,2.47Z"
            fill="#f8dbb2"
          />
          <path
            d="M250.49,104.09c-.42,1.95,1.13,2.95,2.06,4.26-3.62,2.23-7.9,2.3-11.81,3.63-6.45,2.19-12.97,4.16-19.49,6.11-1.03,.31-2.06,1.22-3.3,.55,1.99-2.12,25.28-12.52,32.55-14.54Z"
            fill="#fddf79"
          />
          <path
            d="M178.87,133.35c.09-2.02,.19-4.03,.28-6.05,1.37,1.14,.88,2.71,.94,4.14,.25,5.44,.64,5.84,6.02,5.89,.66,0,1.31-.01,1.97-.02-.11,4.02-.23,8.04-.34,12.06-1.48,.06-2.99-.05-4.43,.21-2.18,.4-3.67,1.51-2.96,4.1l-.44,9.67c-.24-.02-.49-.03-.73-.05-.08-.97-.16-1.93-.24-2.9-.02-9.02-.05-18.04-.07-27.05Z"
            fill="#f8dbb2"
          />
          <path
            d="M105.14,295.76c4.12,.66,8.16-.46,12.26-.45,34.01,.01,68.02-.07,102.03,.06,8.36,.03,16.76,.24,25.02,1.95,1.42,.29,2.67,.65,2.84,2.28,.17,1.66-1.35,1.59-2.34,2.09-1.58,.8-3.26,.68-4.92,.74-4.38,.18-8.74,1.51-13.15,.08-2.03-.66-3.93,.58-5.88,.9-4.47,.74-8.9,.01-13.35,0-15.08-.05-30.16-.02-45.24-.02-14.91,0-29.83-.32-44.73,.15-6.81,.22-13.42-1.04-20.14-1.24-1.45-.04-2.91-.71-4.32-1.2-.81-.28-1.46-.87-1.39-1.86,.07-.97,.76-1.57,1.58-1.72,3.88-.69,7.65-2.32,11.72-1.77Z"
            fill="#e0e7ea"
          />
          <path
            d="M241.81,164.41c1.87,1.98,2.96,4.37,3.66,6.96,.11,.84,.1,1.73,1.01,2.21,0,0-.01-.02-.01-.02-.27,3.67,1.21,7.14,1.09,10.84-.11,3.17-1.51,6.15-1.07,9.34,0,0,.04-.07,.04-.07-.32,.34-.65,.67-.97,1.01,.4,2.09-.97,3.85-1.13,5.83-.6,.83-2.06,1.21-1.32,3,1.75-.71,3.5-1.42,5.25-2.13,4.09-.18,7.75,1.04,11.05,3.42,.07,.34,.14,.68,.21,1.02,.53,4.54-1.53,8.67-2.05,13.04,0,0,.01-.02,.01-.02-1.32,.56-1.94,1.61-2.05,3,0,0,0,.01,0,.01-.33,.34-.66,.68-.99,1.02,0,0,.01-.01,.01-.01-.34,.34-.68,.68-1.02,1.02,0,0,.01-.01,.01-.01-2.8,.11-2.26-3.13-4.06-4.02,0,0,.03,.05,.03,.05-.03-.85-.15-1.66-1.06-2.05,0,0,.06,.06,.06,.06-.4-.92-1.22-1.01-2.06-1.06,0,0,.06,.03,.06,.03-1.01-1.34-2.03-1.32-3.05,0,0,0,.06-.03,.06-.03-1.75-.07-3.32,.21-4.07,2.09,0,0,.08-.08,.08-.08-1.08,.72-2.15,1.45-3.23,2.17-1.67-.29-3.51,.28-4.98-1,1.27-3.28,3.49-5.63,6.72-7.06,1.52-.67,2.94-1.53,3.05-3.5-6.56-1.63-7.29-2.68-6.64-9.4,.08-.82,.32-1.63,.51-2.44,1.95-8.67,3.71-17.35,2.68-26.34-.35-3.04,1.53-5.75,4.18-6.88Z"
            fill="#ebb740"
          />
          <path
            d="M241.81,164.41c-2.65,1.13-4.53,3.83-4.18,6.88,1.03,9-.73,17.67-2.68,26.34-.18,.81-.43,1.62-.51,2.44-.65,6.72,.09,7.76,6.64,9.4-.11,1.97-1.53,2.82-3.05,3.5-3.23,1.43-5.45,3.78-6.72,7.06-1.69,0-3.38,0-5.07,.01-.58-.09-1.16-.19-1.75-.28-.05-1.4-.55-2.68-1.13-3.93,2.85-.78,3.74-1.92,2.47-3.69-1.61-2.25-3.35-4.61-6.66-4.46,.36-2.79,1.07-5.49,2.12-8.1,1.7-.05,2.62,2.06,4.45,1.74,1.06-1.62,.55-3.32,.5-4.9-.14-4.51,.74-8.86,1.63-13.25,1.65-8.1,5.62-15.16,9.47-22.29,3.09-.83,3.36,1.87,4.45,3.55Z"
            fill="#f7c942"
          />
          <path
            d="M190.19,182.37c-9.1,.41-18.21,.28-27.31,.1-.01-.49,.16-1.28-.06-1.43-3.77-2.35-2.75-6.09-2.88-9.5-.05-1.43,.34-3-1.02-4.11,0-1.76,0-3.51,0-5.27,1.85-2,.47-4.55,1.18-6.74,.83,.02,1.66,.03,2.5,.04,.4,1,.81,2,1.21,3-1.35,3.04-1.59,6.06,.17,9.05,.03,.31,.03,.62,0,.93-2.8,1.28-1.25,3.55-.84,5.15,1.22,4.77,6.35,6.23,10.28,3.24,2.82-2.14,2.83-5.05,2.51-8.11,.78-1.49,2.7-1.16,3.68-2.48,.95,1.36-.07,3.06,1.05,4.41q.87-7.03,7.69-7.21c1.23,6.25,1.33,12.61,1.85,18.93Z"
            fill="#ebb740"
          />
          <path
            d="M237.37,160.86c-3.85,7.14-7.82,14.19-9.47,22.29-.9,4.39-1.77,8.74-1.63,13.25,.05,1.58,.55,3.28-.5,4.9-1.83,.32-2.75-1.79-4.45-1.74-11.61-5.6-14.58,.78-15.14,9.1-.09,1.34,.06,2.69-.02,4.02-.15,2.51,1.67,4.82,.74,7.4-3.26-4.96-4.37-10.45-3.7-16.27,1.14-9.89,8.87-13.61,17.44-8.48,.7,.42,1.36,.88,2.37,1.53,.96-1.66,.46-3.16,.18-4.45-2.23-10.32,1.4-18.77,8.24-26.2,1.81-1.96,3.55-4.03,5.94-5.35Z"
            fill="#f8dbb2"
          />
          <path
            d="M188.34,163.44q-6.83,.18-7.69,7.21c-1.12-1.34-.09-3.04-1.05-4.41-.98,1.31-2.9,.99-3.68,2.48-1.6-1.16-2.44-3.47-4.95-3.23l.05,.03c-1.08-1.31-2.19-.99-3.31-.06-1.62,0-2.48,1.38-3.73,2.05-1.76-2.98-1.52-6.01-.17-9.05,6.12,3.79,9.44,2.97,12.43-3.09,.59,0,1.18,0,1.78,0,.24,1.69-.57,3.58,.92,5.04,.08,.97,.16,1.93,.24,2.9,.24,.02,.49,.03,.73,.05,.15-3.22,.29-6.45,.44-9.67,2.51-.07,5.02-.13,7.53-.2,.15,3.32,.31,6.64,.46,9.96Z"
            fill="#f7c942"
          />
          <path
            d="M206.89,220.09c.94-2.58-.88-4.89-.74-7.4,.08-1.34-.07-2.69,.02-4.02,.56-8.32,3.53-14.71,15.14-9.1-1.04,2.61-1.75,5.31-2.12,8.1-3.21-.16-6.4-.15-8.27,3.11-1.02,1.77-1.34,3.5,1.39,4.1,0,.36,0,.72-.01,1.08-.98,1.3-1.97,2.61-2.95,3.91-.78,.05-1.56,.09-2.34,.14l-.1,.08Z"
            fill="#fddf79"
          />
          <path
            d="M238.39,230.85c-.66-.35-1.32-.7-1.98-1.05-1.04-1.76-3.64-.12-4.79-2.08,2.01-2.97,4.11-5.37,8.06-4.9,.55,.07,1.17-.48,1.76-.74,3.78,3.47,3.56,6.01-.73,8.06-.72,.34-1.54,.48-2.32,.71Z"
            fill="#ebb740"
          />
          <path
            d="M226.25,220.03c1.69,0,3.38,0,5.07-.01,1.47,1.28,3.31,.71,4.98,1-.45,.51-1.03,.7-1.69,.82-4.93,.86-6.03,2.2-6.22,7.42-2.5-.16-5.01-.32-7.51-.48-.18-.31-.37-.61-.55-.92,2.27-2.38,4.83-4.55,5.92-7.82Z"
            fill="#f8dbb2"
          />
          <path
            d="M248.36,201.38c-1.75,.71-3.5,1.42-5.25,2.13-.74-1.79,.72-2.17,1.32-3,1.44-.14,2.27-1.32,3.37-2.02,6.33-4,11.02-2.13,13.02,5.24-.21,.8-.41,1.61-1.2,2.09-.07-.34-.14-.68-.21-1.02-1.99-5.53-6.68-6.98-11.05-3.42Z"
            fill="#f8dbb2"
          />
          <path
            d="M228.38,229.25c.19-5.22,1.3-6.56,6.22-7.42,.67-.12,1.24-.31,1.69-.82,1.07-.72,2.15-1.44,3.22-2.17-.37,1.68-.37,3.14,1.92,3.24-.59,.26-1.21,.81-1.76,.74-3.96-.47-6.06,1.93-8.06,4.9,1.15,1.95,3.75,.32,4.79,2.08-2.68-.14-5.43,.67-8.04-.56Z"
            fill="#fddf79"
          />
          <path
            d="M226.25,220.03c-1.09,3.28-3.65,5.44-5.92,7.82-3.42-4.24-2.51-6.72,2.93-8.04,.42-.02,.83-.04,1.25-.06,.58,.09,1.16,.19,1.75,.28Z"
            fill="#e0e7ea"
          />
          <path
            d="M187.88,153.48c-2.51,.07-5.02,.13-7.53,.2-.71-2.59,.79-3.7,2.96-4.1,1.44-.26,2.95-.15,4.43-.21,.05,1.37,.09,2.74,.14,4.11Z"
            fill="#fddf79"
          />
          <path
            d="M259.62,205.83c.79-.48,.99-1.29,1.2-2.09,1.71,5.65,.08,10.57-3.25,15.13,.52-4.37,2.58-8.5,2.05-13.04Z"
            fill="#fddf79"
          />
          <path
            d="M246.49,193.75c-.43-3.2,.97-6.17,1.07-9.34,.13-3.71-1.36-7.18-1.09-10.84,3.22,6.73,2.94,13.46,.01,20.19Z"
            fill="#fddf79"
          />
          <path
            d="M249.47,219.85c1.8,.89,1.27,4.14,4.06,4.02-.6,1.01-1.38,2.06-2.62,1.83-1.21-.22-.9-1.55-1.05-2.45-.18-1.13-.27-2.27-.39-3.4Z"
            fill="#fddf79"
          />
          <path
            d="M221.91,216.2c-2.43-1.08-4.96-1.59-7.62-1.36,0,0,0-.01,0-.01,2.95-1.75,5.7-1.99,8.04,1.02-.14,.12-.28,.23-.41,.35Z"
            fill="#f8dbb2"
          />
          <path
            d="M207,220.02c.78-.05,1.56-.09,2.34-.14-.23,.98,.22,2.58-1.36,2.49-.95-.05-1.01-1.39-.99-2.35Z"
            fill="#f8dbb2"
          />
          <path
            d="M239.44,218.93c.74-1.89,2.32-2.16,4.07-2.09-1.23,.94-2.57,1.67-4.07,2.09Z"
            fill="#fddf79"
          />
          <path
            d="M224.5,219.74c-.42,.02-.83,.04-1.25,.06,.49-1.55-.84-2.43-1.34-3.61,.14-.12,.27-.23,.41-.35,.35-.01,.7-.02,1.05-.03,.58,1.25,1.07,2.53,1.13,3.93Z"
            fill="#f8dbb2"
          />
          <path
            d="M255.53,221.84c.11-1.39,.72-2.44,2.05-3-.16,1.35-.93,2.3-2.05,3Z"
            fill="#fddf79"
          />
          <path
            d="M243.45,216.86c1.02-1.31,2.04-1.33,3.05,0-1.02,0-2.03,0-3.05,0Z"
            fill="#fddf79"
          />
          <path
            d="M212.29,215.96c0-.36,0-.72,.01-1.08,.66-.02,1.31-.04,1.97-.05,0,0,0,.01,0,.01-.45,.75-1.2,.97-1.99,1.13Z"
            fill="#f8dbb2"
          />
          <path
            d="M246.44,216.84c.84,.05,1.66,.15,2.06,1.06-.9,.07-1.56-.35-2.06-1.06Z"
            fill="#fddf79"
          />
          <path
            d="M248.44,217.84c.91,.4,1.03,1.2,1.06,2.05-.79-.46-1.12-1.15-1.06-2.05Z"
            fill="#fddf79"
          />
          <path
            d="M246.49,173.58c-.91-.47-.9-1.37-1.01-2.21,.68,.58,.96,1.34,1.01,2.21Z"
            fill="#fddf79"
          />
          <path
            d="M220.34,231.49c-.06,.95,.04,1.98-1.08,2.46-.23-1.08,.32-1.82,1.08-2.46Z"
            fill="#f8dbb2"
          />
          <path
            d="M219.29,233.88c-.04,.66-.29,1.1-1.04,1.05,.06-.64,.27-1.12,1.04-1.05Z"
            fill="#f8dbb2"
          />
          <path
            d="M245.56,194.68c.32-.34,.65-.67,.97-1.01-.08,.57-.45,.86-.97,1.01Z"
            fill="#fddf79"
          />
          <path
            d="M253.52,223.88c.34-.34,.68-.68,1.02-1.02-.34,.34-.68,.68-1.02,1.02Z"
            fill="#fddf79"
          />
          <path
            d="M254.53,222.87c.33-.34,.66-.68,.99-1.02-.12,.54-.46,.87-.99,1.02Z"
            fill="#fddf79"
          />
          <path
            d="M178.02,155.36c-.59,0-1.18,0-1.78,0-.56-7.33-3.72-9.43-10.33-6.89-.82,.34-1.44,.89-1.78,1.72-.37,.09-.73,.19-1.1,.28-2.76-3.25-2.81-3.97-.66-7.53,.5-.82,.92-1.68,1.38-2.52,5.72,4.73,9.68,3.74,12.58-3.15,.56-.02,1.13-.04,1.69-.06,0,6.05,0,12.1,0,18.14Z"
            fill="#f8dbb2"
          />
          <path
            d="M176.33,137.27c-2.9,6.89-6.86,7.89-12.58,3.15-1.15-1.91-.82-4.08-1.1-6.14,.34-.36,.68-.72,1.02-1.09,.18,.06,.36,.08,.54,.09-.03,.64-.05,1.27-.08,1.91,.2,1.68,.12,3.71,2.83,2.26,.67,0,1.35,.02,2.02,.02,2.29,1.58,2.97-.57,3.63-1.84,.75-1.43,.57-2.97-1.48-3.44-.35-.35-.69-.7-1.04-1.04-.04-.54-.07-1.09-.11-1.63,3.38,.01,5.02,2.19,6.17,4.97-.03,.27,.01,.53,.13,.77,.01,.67,.02,1.34,.04,2.02Z"
            fill="#9eafb3"
          />
          <path
            d="M162.65,134.28c.28,2.06-.05,4.23,1.1,6.14-.46,.84-.89,1.7-1.38,2.52-2.15,3.56-2.1,4.28,.66,7.53-.14,1.66-.28,3.32-.42,4.98-.83-.01-1.67-.03-2.5-.04-.01-7.03-.02-14.06-.03-21.09,.86-.02,1.72-.03,2.58-.05Z"
            fill="#fddf79"
          />
          <path
            d="M178.02,155.36c0-6.05,0-12.1,0-18.14,0-1.35-.4-2.79,.85-3.87,.02,9.02,.05,18.04,.07,27.06-1.5-1.47-.69-3.35-.92-5.04Z"
            fill="#fddf79"
          />
          <path
            d="M169.99,129.52c.04,.54,.07,1.09,.1,1.64-2.26-.12-4.26,.49-5.89,2.13-.18,0-.36-.03-.54-.09,1.13-2.91,3.27-4.08,6.33-3.68Z"
            fill="#bdcbd3"
          />
          <path
            d="M176.29,135.26c-.12-.24-.16-.5-.13-.77,.14,.17,.29,.33,.41,.52,.01,.02-.18,.16-.28,.25Z"
            fill="#f8dbb2"
          />
          <path
            d="M102.57,199.72c-.04,.5-.04,1-.11,1.5-.15,1.06-.6,1.99-1.75,2.13-1.2,.15-1.8-.79-2.17-1.73-1.64-4.19-2.97-8.46-4.14-12.81-.97-3.6,.26-6.89,.39-10.31,.03-.91,.76-1.84,1.3-2.67,.24-.37,.8-.74,1.22-.74,.75,0,1.07,.61,1.15,1.35,.34,3.3,.54,6.63,1.09,9.9,.65,3.87,.56,7.98,3,11.39,.01,.66,.03,1.33,.04,1.99Z"
            fill="#c68f43"
          />
          <path
            d="M126.64,214.9c-.65-.03-1.3-.05-1.95-.08-2.94-1.73-5.7-1.99-8.04,1.02-.66,.35-1.32,.69-1.98,1.04-2.62-4.01-2.45-4.48,.96-7.69,1.24-1.17,3.14-1.03,4.09-2.51,3.75-.58,6.42,1.19,8.34,4.13,1.12,1.71,1.3,3.51-1.41,4.09Z"
            fill="#ebb740"
          />
          <path
            d="M105.69,167.44c.61,.04,1.23,.09,1.84,.13,1.33,4.55,3.82,8.69,4.71,13.4,.36,1.92,.93,3.86-.42,5.65-2.44-3.66-2.47-8.13-3.99-12.12-.87-2.27-2.64-4.36-2.14-7.07Z"
            fill="#fddf79"
          />
          <path
            d="M111.85,188.51c2.4,1,2.06,2.49,.75,4.16-1.44-1.17-.92-2.7-.75-4.16Z"
            fill="#fddf79"
          />
          <path
            d="M83.29,220c-.63-.38-1.26-.77-1.88-1.15-.75-4.34-2.68-8.5-2.04-13.06,.08-.3,.14-.62,.17-.93,.6-.12,1.2-.25,1.8-.37,2.45,3.24,3.07,7.28,4.72,10.87,1.11,2.41,0,4.18-2.76,4.64Z"
            fill="#c68f43"
          />
          <path
            d="M115.61,196.68c-.19,.21-.37,.43-.56,.64-.11-.56-.11-.98,.63-.54,0,0-.07-.1-.07-.1Z"
            fill="#d12438"
          />
          <path
            d="M123.67,248.02c.53,1.37,1.59,1.97,3,2.07,.83,1.67,2.4,2.54,3.84,3.54-1.05,1.33-2.53,1.39-4.05,1.39-10.45,.02-20.91,.08-31.36,.1-1.28,0-2.71,.28-3.56-1.15,1.36-2.68,4.19-3.71,6.35-5.45,2.86-2.31,5.52-4.73,7.75-7.64,2.83-3.69,3.27-3.67,6.98-.42,2.46,2.16,4.76,4.59,8.06,5.57,0,0-.02-.02-.02-.02,.56,1.36,1.59,2.01,3.04,2.03l-.02-.02Z"
            fill="#f7c942"
          />
          <path
            d="M112.64,229.46c.35-.16,.7-.31,1.05-.46-.26,.35-.56,.62-1.05,.46Z"
            fill="#fddf79"
          />
          <path
            d="M123.69,248.04c-1.46-.02-2.48-.67-3.04-2.03,1.56-.15,2.96-.05,3.04,2.03Z"
            fill="#c68f43"
          />
          <path
            d="M240.3,247.2c1.66,3.01,5.45,3.77,7.11,6.76-.85,1.43-2.29,1.16-3.58,1.16-10.68-.02-21.37-.05-32.05-.12-1.27,0-2.75,.34-3.49-1.25,.32-.56,.65-1.12,.97-1.68,1.4-.07,2.42-.71,3.04-1.98,1.4-.08,2.4-.75,3.04-1.99,1.38-.1,2.38-.8,3.03-2,3.4-1.46,6.08-3.92,8.79-6.35,2.75-2.46,2.95-2.32,5.47,.56,2.27,2.59,4.22,5.6,7.68,6.89Z"
            fill="#f7c942"
          />
          <path
            d="M174.99,246.05c1.26,1.87,2.69,3.53,5.07,3.98,1.06,1.27,2.11,2.54,3.17,3.81-9.17,.33-18.34,.36-27.51-.02,1.06-1.26,2.13-2.53,3.19-3.79,2.82-.69,4.48-2.8,6.09-4.97,.47-.16,1.07-.2,1.39-.51,2.31-2.26,4.39-1.99,6.4,.41,.55,.66,1.34,.98,2.2,1.09Z"
            fill="#fddf79"
          />
          <path
            d="M154.59,271.38h29.71c-1.54,3.62-3.98,5.03-7.78,4.83-4.5-.24-9.03-.25-13.52,0-3.72,.21-6.48-.83-8.41-4.83Z"
            fill="#bdcbd3"
          />
          <path
            d="M118.26,272.15c1.44,.1,3.32-.26,4.91,1.06,1.71,1.42,1.66,2.95-.36,3.83-3.69,1.6-7.45,1.6-11.19,.08-.79-.32-1.54-.78-1.67-1.68-.17-1.2,.75-1.74,1.62-2.26,1.97-1.2,4.16-1.05,6.7-1.02Z"
            fill="#bdcbd3"
          />
          <path
            d="M225.19,277.75c-2.24,.44-4.48,.42-6.73,.03-1.05-1.58-2.68-3.05-1-5.16,.63-.07,1.26-.13,1.89-.2,1.33,1.08,2.65,1.1,3.96-.04,.96,.09,1.92,.17,2.88,.26,1.63,2.09,.08,3.55-1,5.11Z"
            fill="#e0e7ea"
          />
          <path
            d="M217.46,272.62c-1.67,2.11-.04,3.58,1,5.16-.63-.02-1.35,.15-1.89-.08-1.3-.56-3.26-.96-2.84-2.8,.36-1.6,1.69-2.82,3.73-2.28Z"
            fill="#bdcbd3"
          />
          <path
            d="M225.19,277.75c1.08-1.56,2.63-3.02,1-5.11,1.06-.43,1.91-.03,2.67,.68,1.69,1.58,1.59,2.57-.45,3.77-.97,.57-1.99,1.21-3.22,.65Z"
            fill="#bdcbd3"
          />
          <path
            d="M223.31,272.39c-1.31,1.14-2.63,1.12-3.96,.04,1.31-1.55,2.63-1.51,3.96-.04Z"
            fill="#bdcbd3"
          />
          <path
            d="M248.36,201.38c4.37-3.56,9.06-2.1,11.05,3.42-3.3-2.38-6.96-3.6-11.05-3.42Z"
            fill="#fddf79"
          />
          <path
            d="M214.28,214.82c-.66,.02-1.31,.04-1.97,.05-2.73-.59-2.41-2.32-1.39-4.1,1.87-3.26,5.06-3.27,8.27-3.11,3.31-.16,5.04,2.21,6.65,4.46,1.26,1.76,.38,2.9-2.47,3.69-.35,.01-.7,.02-1.05,.03-2.34-3.01-5.1-2.77-8.04-1.02Z"
            fill="#ebb740"
          />
          <path
            d="M162.6,155.46c.14-1.66,.28-3.32,.42-4.98,.37-.09,.73-.19,1.1-.28-.14,1.35-.1,2.65,.9,3.74,1.25,1.37,2.75,1.94,4.46,1.12,1.6-.77,2.63-2.07,2.42-3.97-.23-2.07-1.65-2.73-3.5-2.73-.83,0-1.66,.08-2.49,.12,6.62-2.54,9.77-.43,10.33,6.89-2.99,6.06-6.31,6.88-12.43,3.09-.41-1-.81-2-1.21-3Z"
            fill="#9eafb3"
          />
          <path
            d="M170.98,165.49c2.51-.25,3.35,2.07,4.95,3.23,.32,3.06,.31,5.97-2.51,8.11-3.92,2.98-9.06,1.53-10.28-3.24-.41-1.6-1.96-3.88,.84-5.15,.81,3.97,2.31,5.5,4.81,4.92,2.58-.59,3.57-2.93,2.73-6.47-.12-.48-.36-.93-.55-1.4Z"
            fill="#9eafb3"
          />
          <path
            d="M170.98,165.49c.19,.47,.43,.92,.55,1.4,.84,3.54-.15,5.88-2.73,6.47-2.5,.58-4-.95-4.81-4.92,.03-.31,.03-.62,0-.93,1.25-.67,2.11-2.06,3.74-2.05,1.11,.02,2.21,.04,3.31,.06l-.05-.03Z"
            fill="#e0e7ea"
          />
          <path
            d="M171.03,165.52c-1.1-.02-2.21-.04-3.31-.06,1.12-.93,2.23-1.24,3.31,.06Z"
            fill="#9eafb3"
          />
          <path
            d="M165.91,148.48c.83-.04,1.66-.12,2.49-.12,1.86,0,3.28,.67,3.5,2.73,.21,1.91-.82,3.21-2.42,3.97-1.71,.82-3.21,.26-4.46-1.12-1-1.09-1.03-2.39-.9-3.74,.34-.84,.97-1.38,1.78-1.73Z"
            fill="#e0e7ea"
          />
          <path
            d="M164.21,133.29c1.63-1.64,3.63-2.25,5.89-2.13,.35,.35,.69,.69,1.04,1.04,.28,2.16-1.24,3.6-2.15,5.28-.67,0-1.35-.02-2.02-.03-.47-1.34-1.47-2.03-2.83-2.26,.03-.64,.05-1.27,.08-1.91Z"
            fill="#e0e7ea"
          />
          <path
            d="M168.99,137.48c.91-1.68,2.43-3.11,2.15-5.28,2.06,.47,2.23,2.01,1.49,3.44-.66,1.27-1.34,3.42-3.63,1.84Z"
            fill="#bdcbd3"
          />
          <path
            d="M164.13,135.19c1.36,.23,2.36,.92,2.83,2.26-2.71,1.45-2.63-.58-2.83-2.26Z"
            fill="#bdcbd3"
          />
        </g>
        <rect width="338.32" height="338.32" fill="none" />
      </g>
    </svg>
  );
}

export default RoyalMailIcon;
